(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired444"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired444"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f13ecebb1f16f955$export$f7ad0328861e2f03, (v) => $f13ecebb1f16f955$export$f7ad0328861e2f03 = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

parcelRegister("2x8QE", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("gD9Ug")).default);
/**
 * Swiper 6.8.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 23, 2021
 */ 
var $gD9Ug = parcelRequire("gD9Ug");

var $80uky = parcelRequire("80uky");

var $aRqkj = parcelRequire("aRqkj");

var $gIciZ = parcelRequire("gIciZ");

var $egtsK = parcelRequire("egtsK");

var $9FVzM = parcelRequire("9FVzM");

var $hqsPh = parcelRequire("hqsPh");

var $7j3Wv = parcelRequire("7j3Wv");

var $hUEmN = parcelRequire("hUEmN");

var $gpbet = parcelRequire("gpbet");

var $3J7Lh = parcelRequire("3J7Lh");

var $lLvEQ = parcelRequire("lLvEQ");

var $iGlyi = parcelRequire("iGlyi");

var $k7pzD = parcelRequire("k7pzD");

var $lXyaT = parcelRequire("lXyaT");

var $8uDNg = parcelRequire("8uDNg");

var $l6k8I = parcelRequire("l6k8I");

var $9lTns = parcelRequire("9lTns");

var $cnVyI = parcelRequire("cnVyI");

var $7jHm9 = parcelRequire("7jHm9");
// Swiper Class
var $1d8586e2b7010a1e$var$components = [
    (0, $80uky.default),
    (0, $aRqkj.default),
    (0, $gIciZ.default),
    (0, $egtsK.default),
    (0, $9FVzM.default),
    (0, $hqsPh.default),
    (0, $7j3Wv.default),
    (0, $hUEmN.default),
    (0, $gpbet.default),
    (0, $3J7Lh.default),
    (0, $lLvEQ.default),
    (0, $iGlyi.default),
    (0, $k7pzD.default),
    (0, $lXyaT.default),
    (0, $8uDNg.default),
    (0, $l6k8I.default),
    (0, $9lTns.default),
    (0, $cnVyI.default),
    (0, $7jHm9.default)
];
(0, $gD9Ug.default).use($1d8586e2b7010a1e$var$components);

});
parcelRegister("gD9Ug", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b7f90efdaa68fa$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");

var $eDC3w = parcelRequire("eDC3w");

var $i6q4Z = parcelRequire("i6q4Z");

var $disVx = parcelRequire("disVx");

var $eL251 = parcelRequire("eL251");

var $8sY3f = parcelRequire("8sY3f");

var $aauNC = parcelRequire("aauNC");

var $2ZHgR = parcelRequire("2ZHgR");

var $j9FfP = parcelRequire("j9FfP");

var $fE0Dv = parcelRequire("fE0Dv");

var $f99uy = parcelRequire("f99uy");

var $72SZ0 = parcelRequire("72SZ0");

var $4HlIn = parcelRequire("4HlIn");

var $dgcSH = parcelRequire("dgcSH");

var $gNU39 = parcelRequire("gNU39");

var $cV85Y = parcelRequire("cV85Y");

var $34o6B = parcelRequire("34o6B");

var $8njGS = parcelRequire("8njGS");

var $9aGma = parcelRequire("9aGma");

var $hTnVL = parcelRequire("hTnVL");

var $9xsLN = parcelRequire("9xsLN");
function $c1b7f90efdaa68fa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c1b7f90efdaa68fa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c1b7f90efdaa68fa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c1b7f90efdaa68fa$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $c1b7f90efdaa68fa$var$prototypes = {
    modular: (0, $aauNC.default),
    eventsEmitter: (0, $2ZHgR.default),
    update: (0, $j9FfP.default),
    translate: (0, $fE0Dv.default),
    transition: (0, $f99uy.default),
    slide: (0, $72SZ0.default),
    loop: (0, $4HlIn.default),
    grabCursor: (0, $dgcSH.default),
    manipulation: (0, $gNU39.default),
    events: (0, $cV85Y.default),
    breakpoints: (0, $34o6B.default),
    checkOverflow: (0, $hTnVL.default),
    classes: (0, $8njGS.default),
    images: (0, $9aGma.default)
};
var $c1b7f90efdaa68fa$var$extendedDefaults = {};
var $c1b7f90efdaa68fa$var$Swiper = /*#__PURE__*/ function() {
    function Swiper() {
        var el;
        var params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else {
            el = args[0];
            params = args[1];
        }
        if (!params) params = {};
        params = (0, $8Ji4q.extend)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $1Lk6P.default)(params.el).length > 1) {
            var swipers = [];
            (0, $1Lk6P.default)(params.el).each(function(containerEl) {
                var newParams = (0, $8Ji4q.extend)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            return swipers;
        } // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $eDC3w.getSupport)();
        swiper.device = (0, $i6q4Z.getDevice)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $disVx.getBrowser)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        if (typeof swiper.modules === "undefined") swiper.modules = {};
        Object.keys(swiper.modules).forEach(function(moduleName) {
            var module = swiper.modules[moduleName];
            if (module.params) {
                var moduleParamName = Object.keys(module.params)[0];
                var moduleParams = module.params[moduleParamName];
                if (typeof moduleParams !== "object" || moduleParams === null) return;
                if ([
                    "navigation",
                    "pagination",
                    "scrollbar"
                ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
                    auto: true
                };
                if (!(moduleParamName in params && "enabled" in moduleParams)) return;
                if (params[moduleParamName] === true) params[moduleParamName] = {
                    enabled: true
                };
                if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
                if (!params[moduleParamName]) params[moduleParamName] = {
                    enabled: false
                };
            }
        }); // Extend defaults with modules params
        var swiperParams = (0, $8Ji4q.extend)({}, (0, $9xsLN.default));
        swiper.useParams(swiperParams); // Extend defaults with passed params
        swiper.params = (0, $8Ji4q.extend)({}, swiperParams, $c1b7f90efdaa68fa$var$extendedDefaults, params);
        swiper.originalParams = (0, $8Ji4q.extend)({}, swiper.params);
        swiper.passedParams = (0, $8Ji4q.extend)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $1Lk6P.default); // Extend Swiper
        (0, $8Ji4q.extend)(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $1Lk6P.default)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function isHorizontal() {
                return swiper.params.direction === "horizontal";
            },
            isVertical: function isVertical() {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                var touch = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel"
                ];
                var desktop = [
                    "mousedown",
                    "mousemove",
                    "mouseup"
                ];
                if (swiper.support.pointerEvents) desktop = [
                    "pointerdown",
                    "pointermove",
                    "pointerup"
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $8Ji4q.now)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        }); // Install Modules
        swiper.useModules();
        swiper.emit("_swiper"); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        return swiper;
    }
    var _proto = Swiper.prototype;
    _proto.enable = function enable() {
        var swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    };
    _proto.disable = function disable() {
        var swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    };
    _proto.setProgress = function setProgress(progress, speed) {
        var swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        var min = swiper.minTranslate();
        var max = swiper.maxTranslate();
        var current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    };
    _proto.emitContainerClasses = function emitContainerClasses() {
        var swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        var classes = swiper.el.className.split(" ").filter(function(className) {
            return className.indexOf("swiper-container") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", classes.join(" "));
    };
    _proto.getSlideClasses = function getSlideClasses(slideEl) {
        var swiper = this;
        return slideEl.className.split(" ").filter(function(className) {
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    };
    _proto.emitSlidesClasses = function emitSlidesClasses() {
        var swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        var updates = [];
        swiper.slides.each(function(slideEl) {
            var classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    };
    _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
        var swiper = this;
        var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
        var spv = 1;
        if (params.centeredSlides) {
            var slideSize = slides[activeIndex].swiperSlideSize;
            var breakLoop;
            for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(var _i = activeIndex - 1; _i >= 0; _i -= 1)if (slides[_i] && !breakLoop) {
                slideSize += slides[_i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            for(var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1)if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) spv += 1;
        }
        return spv;
    };
    _proto.update = function update() {
        var swiper = this;
        if (!swiper || swiper.destroyed) return;
        var snapGrid = swiper.snapGrid, params = swiper.params; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        var translated;
        if (swiper.params.freeMode) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    };
    _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        var swiper = this;
        var currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each(function(slideEl) {
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    };
    _proto.mount = function mount(el) {
        var swiper = this;
        if (swiper.mounted) return true; // Find el
        var $el = (0, $1Lk6P.default)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        var getWrapperSelector = function getWrapperSelector() {
            return "." + (swiper.params.wrapperClass || "").trim().split(" ").join(".");
        };
        var getWrapper = function getWrapper() {
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                var res = (0, $1Lk6P.default)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = function(options) {
                    return $el.children(options);
                };
                return res;
            }
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        var $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            var document = (0, $6fzuY.getDocument)();
            var wrapper = document.createElement("div");
            $wrapperEl = (0, $1Lk6P.default)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children("." + swiper.params.slideClass).each(function(slideEl) {
                $wrapperEl.append(slideEl);
            });
        }
        (0, $8Ji4q.extend)(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
            wrongRTL: $wrapperEl.css("display") === "-webkit-box"
        });
        return true;
    };
    _proto.init = function init(el) {
        var swiper = this;
        if (swiper.initialized) return swiper;
        var mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit"); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    };
    _proto.destroy = function destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        var swiper = this;
        var params = swiper.params, $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy"); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr("style");
            $wrapperEl.removeAttr("style");
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
        }
        swiper.emit("destroy"); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach(function(eventName) {
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $8Ji4q.deleteProps)(swiper);
        }
        swiper.destroyed = true;
        return null;
    };
    Swiper.extendDefaults = function extendDefaults(newDefaults) {
        (0, $8Ji4q.extend)($c1b7f90efdaa68fa$var$extendedDefaults, newDefaults);
    };
    Swiper.installModule = function installModule(module) {
        if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
        var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + (0, $8Ji4q.now)();
        Swiper.prototype.modules[name] = module;
    };
    Swiper.use = function use(module) {
        if (Array.isArray(module)) {
            module.forEach(function(m) {
                return Swiper.installModule(m);
            });
            return Swiper;
        }
        Swiper.installModule(module);
        return Swiper;
    };
    $c1b7f90efdaa68fa$var$_createClass(Swiper, null, [
        {
            key: "extendedDefaults",
            get: function get() {
                return $c1b7f90efdaa68fa$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return 0, $9xsLN.default;
            }
        }
    ]);
    return Swiper;
}();
Object.keys($c1b7f90efdaa68fa$var$prototypes).forEach(function(prototypeGroup) {
    Object.keys($c1b7f90efdaa68fa$var$prototypes[prototypeGroup]).forEach(function(protoMethod) {
        $c1b7f90efdaa68fa$var$Swiper.prototype[protoMethod] = $c1b7f90efdaa68fa$var$prototypes[prototypeGroup][protoMethod];
    });
});
$c1b7f90efdaa68fa$var$Swiper.use([
    (0, $eL251.default),
    (0, $8sY3f.default)
]);
var $c1b7f90efdaa68fa$export$2e2bcd8739ae039 = $c1b7f90efdaa68fa$var$Swiper;

});
parcelRegister("6fzuY", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $48cfae140074808a$export$f65ca476c09acec0);
$parcel$export(module.exports, "getWindow", () => $48cfae140074808a$export$38b2d434cce3ea22);
/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */ /* eslint-disable no-param-reassign */ function $48cfae140074808a$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $48cfae140074808a$export$8b58be045bf06082(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($48cfae140074808a$var$isObject(src[key]) && $48cfae140074808a$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $48cfae140074808a$export$8b58be045bf06082(target[key], src[key]);
    });
}
var $48cfae140074808a$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ""
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $48cfae140074808a$export$f65ca476c09acec0() {
    var doc = typeof document !== "undefined" ? document : {};
    $48cfae140074808a$export$8b58be045bf06082(doc, $48cfae140074808a$export$3fdcb9b4d81368d8);
    return doc;
}
var $48cfae140074808a$export$8582633f185c62bb = {
    document: $48cfae140074808a$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return "";
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function(id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $48cfae140074808a$export$38b2d434cce3ea22() {
    var win = typeof window !== "undefined" ? window : {};
    $48cfae140074808a$export$8b58be045bf06082(win, $48cfae140074808a$export$8582633f185c62bb);
    return win;
}

});

parcelRegister("1Lk6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $1489c77f32a7b3b8$export$2e2bcd8739ae039);

var $25g61 = parcelRequire("25g61");
var $1489c77f32a7b3b8$var$Methods = {
    addClass: (0, $25g61.addClass),
    removeClass: (0, $25g61.removeClass),
    hasClass: (0, $25g61.hasClass),
    toggleClass: (0, $25g61.toggleClass),
    attr: (0, $25g61.attr),
    removeAttr: (0, $25g61.removeAttr),
    transform: (0, $25g61.transform),
    transition: (0, $25g61.transition),
    on: (0, $25g61.on),
    off: (0, $25g61.off),
    trigger: (0, $25g61.trigger),
    transitionEnd: (0, $25g61.transitionEnd),
    outerWidth: (0, $25g61.outerWidth),
    outerHeight: (0, $25g61.outerHeight),
    styles: (0, $25g61.styles),
    offset: (0, $25g61.offset),
    css: (0, $25g61.css),
    each: (0, $25g61.each),
    html: (0, $25g61.html),
    text: (0, $25g61.text),
    is: (0, $25g61.is),
    index: (0, $25g61.index),
    eq: (0, $25g61.eq),
    append: (0, $25g61.append),
    prepend: (0, $25g61.prepend),
    next: (0, $25g61.next),
    nextAll: (0, $25g61.nextAll),
    prev: (0, $25g61.prev),
    prevAll: (0, $25g61.prevAll),
    parent: (0, $25g61.parent),
    parents: (0, $25g61.parents),
    closest: (0, $25g61.closest),
    find: (0, $25g61.find),
    children: (0, $25g61.children),
    filter: (0, $25g61.filter),
    remove: (0, $25g61.remove)
};
Object.keys($1489c77f32a7b3b8$var$Methods).forEach(function(methodName) {
    Object.defineProperty((0, $25g61.$).fn, methodName, {
        value: $1489c77f32a7b3b8$var$Methods[methodName],
        writable: true
    });
});
var $1489c77f32a7b3b8$export$2e2bcd8739ae039 = (0, $25g61.$);

});
parcelRegister("25g61", function(module, exports) {

$parcel$export(module.exports, "$", () => $);
$parcel$export(module.exports, "addClass", () => addClass);
$parcel$export(module.exports, "removeClass", () => removeClass);
$parcel$export(module.exports, "toggleClass", () => toggleClass);
$parcel$export(module.exports, "hasClass", () => hasClass);
$parcel$export(module.exports, "attr", () => attr);
$parcel$export(module.exports, "removeAttr", () => removeAttr);
$parcel$export(module.exports, "transform", () => transform);
$parcel$export(module.exports, "transition", () => transition);
$parcel$export(module.exports, "on", () => on);
$parcel$export(module.exports, "off", () => off);
$parcel$export(module.exports, "trigger", () => trigger);
$parcel$export(module.exports, "transitionEnd", () => transitionEnd);
$parcel$export(module.exports, "outerWidth", () => outerWidth);
$parcel$export(module.exports, "outerHeight", () => outerHeight);
$parcel$export(module.exports, "offset", () => offset);
$parcel$export(module.exports, "styles", () => styles);
$parcel$export(module.exports, "css", () => css);
$parcel$export(module.exports, "each", () => each);
$parcel$export(module.exports, "filter", () => filter);
$parcel$export(module.exports, "html", () => html);
$parcel$export(module.exports, "text", () => text);
$parcel$export(module.exports, "is", () => is);
$parcel$export(module.exports, "index", () => index);
$parcel$export(module.exports, "eq", () => eq);
$parcel$export(module.exports, "append", () => append);
$parcel$export(module.exports, "prepend", () => prepend);
$parcel$export(module.exports, "next", () => next);
$parcel$export(module.exports, "nextAll", () => nextAll);
$parcel$export(module.exports, "prev", () => prev);
$parcel$export(module.exports, "prevAll", () => prevAll);
$parcel$export(module.exports, "parent", () => parent);
$parcel$export(module.exports, "parents", () => parents);
$parcel$export(module.exports, "closest", () => closest);
$parcel$export(module.exports, "find", () => find);
$parcel$export(module.exports, "children", () => children);
$parcel$export(module.exports, "remove", () => remove);
/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */ 
var $6fzuY = parcelRequire("6fzuY");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/* eslint-disable no-proto */ function makeReactive(obj) {
    var proto = obj.__proto__;
    Object.defineProperty(obj, "__proto__", {
        get: function get() {
            return proto;
        },
        set: function set(value) {
            proto.__proto__ = value;
        }
    });
}
var Dom7 = /*#__PURE__*/ function(_Array) {
    _inheritsLoose(Dom7, _Array);
    function Dom7(items) {
        var _this;
        _this = _Array.call.apply(_Array, [
            this
        ].concat(items)) || this;
        makeReactive(_assertThisInitialized(_this));
        return _this;
    }
    return Dom7;
}(/*#__PURE__*/ _wrapNativeSuper(Array));
function arrayFlat(arr) {
    if (arr === void 0) arr = [];
    var res = [];
    arr.forEach(function(el) {
        if (Array.isArray(el)) res.push.apply(res, arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    var uniqueArray = [];
    for(var i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, function(match, group) {
        return group.toUpperCase();
    });
}
function qsa(selector, context) {
    if (typeof selector !== "string") return [
        selector
    ];
    var a = [];
    var res = context.querySelectorAll(selector);
    for(var i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    var window = (0, $6fzuY.getWindow)();
    var document = (0, $6fzuY.getDocument)();
    var arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === "string") {
        var html = selector.trim();
        if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
            var toCreate = "div";
            if (html.indexOf("<li") === 0) toCreate = "ul";
            if (html.indexOf("<tr") === 0) toCreate = "tbody";
            if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0) toCreate = "tr";
            if (html.indexOf("<tbody") === 0) toCreate = "table";
            if (html.indexOf("<option") === 0) toCreate = "select";
            var tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(var i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
function addClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++)classes[_key] = arguments[_key];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(" ");
    }));
    this.forEach(function(el) {
        var _el$classList;
        (_el$classList = el.classList).add.apply(_el$classList, classNames);
    });
    return this;
}
function removeClass() {
    for(var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)classes[_key2] = arguments[_key2];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(" ");
    }));
    this.forEach(function(el) {
        var _el$classList2;
        (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
    });
    return this;
}
function toggleClass() {
    for(var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)classes[_key3] = arguments[_key3];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(" ");
    }));
    this.forEach(function(el) {
        classNames.forEach(function(className) {
            el.classList.toggle(className);
        });
    });
}
function hasClass() {
    for(var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)classes[_key4] = arguments[_key4];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(" ");
    }));
    return arrayFilter(this, function(el) {
        return classNames.filter(function(className) {
            return el.classList.contains(className);
        }).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(var i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(var attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(var i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(var i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(var propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    var el;
    if (typeof value === "undefined") {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        var dataKey = el.getAttribute("data-" + key);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(var i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    var el = this[0];
    if (!el) return undefined;
    var dataset = {}; // eslint-disable-line
    if (el.dataset) for(var dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(var i = 0; i < el.attributes.length; i += 1){
        var _attr = el.attributes[i];
        if (_attr.name.indexOf("data-") >= 0) dataset[toCamelCase(_attr.name.split("data-")[1])] = _attr.value;
    }
    for(var key in dataset){
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === "undefined") {
        // get value
        var el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === "select") {
            var values = [];
            for(var i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(var _i = 0; _i < this.length; _i += 1){
        var _el = this[_i];
        if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === "select") for(var j = 0; j < _el.options.length; j += 1)_el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
        else _el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(var i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(var i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== "string" ? duration + "ms" : duration;
    return this;
}
function on() {
    for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
    var eventType = args[0], targetSelector = args[1], listener = args[2], capture = args[3];
    if (typeof args[1] === "function") {
        eventType = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        var target = e.target;
        if (!target) return;
        var eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            var _parents = $(target).parents(); // eslint-disable-line
            for(var k = 0; k < _parents.length; k += 1)if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
        }
    }
    function handleEvent(e) {
        var eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    var events = eventType.split(" ");
    var j;
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            var event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            var _event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
            el.dom7LiveListeners[_event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(_event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    var eventType = args[0], targetSelector = args[1], listener = args[2], capture = args[3];
    if (typeof args[1] === "function") {
        eventType = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    var events = eventType.split(" ");
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            var handlers = void 0;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(var k = handlers.length - 1; k >= 0; k -= 1){
                var handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once() {
    var dom = this;
    for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
    var eventName = args[0], targetSelector = args[1], listener = args[2], capture = args[3];
    if (typeof args[1] === "function") {
        eventName = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
    }
    function onceHandler() {
        for(var _len8 = arguments.length, eventArgs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)eventArgs[_key8] = arguments[_key8];
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger() {
    var window = (0, $6fzuY.getWindow)();
    for(var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)args[_key9] = arguments[_key9];
    var events = args[0].split(" ");
    var eventData = args[1];
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            if (window.CustomEvent) {
                var evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter(function(data, dataIndex) {
                    return dataIndex > 0;
                });
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionend", fireCallBack);
    }
    if (callback) dom.on("transitionend", fireCallBack);
    return this;
}
function animationEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("animationend", fireCallBack);
    }
    if (callback) dom.on("animationend", fireCallBack);
    return this;
}
function width() {
    var window = (0, $6fzuY.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css("width"));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            var _styles = this.styles();
            return this[0].offsetWidth + parseFloat(_styles.getPropertyValue("margin-right")) + parseFloat(_styles.getPropertyValue("margin-left"));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    var window = (0, $6fzuY.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css("height"));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            var _styles2 = this.styles();
            return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue("margin-top")) + parseFloat(_styles2.getPropertyValue("margin-bottom"));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        var window = (0, $6fzuY.getWindow)();
        var document = (0, $6fzuY.getDocument)();
        var el = this[0];
        var box = el.getBoundingClientRect();
        var body = document.body;
        var clientTop = el.clientTop || body.clientTop || 0;
        var clientLeft = el.clientLeft || body.clientLeft || 0;
        var scrollTop = el === window ? window.scrollY : el.scrollTop;
        var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(var i = 0; i < this.length; i += 1)this[i].style.display = "none";
    return this;
}
function show() {
    var window = (0, $6fzuY.getWindow)();
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.style.display === "none") el.style.display = "";
        if (window.getComputedStyle(el, null).getPropertyValue("display") === "none") // Still not visible
        el.style.display = "block";
    }
    return this;
}
function styles() {
    var window = (0, $6fzuY.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    var window = (0, $6fzuY.getWindow)();
    var i;
    if (arguments.length === 1) {
        if (typeof props === "string") {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(var _prop in props)this[i].style[_prop] = props[_prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === "string") {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach(function(el, index) {
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    var result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === "undefined") return this[0] ? this[0].innerHTML : null;
    for(var i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === "undefined") return this[0] ? this[0].textContent.trim() : null;
    for(var i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    var window = (0, $6fzuY.getWindow)();
    var document = (0, $6fzuY.getDocument)();
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === "undefined") return false;
    if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    var child = this[0];
    var i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === "undefined") return this;
    var length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        var returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append() {
    var newChild;
    var document = (0, $6fzuY.getDocument)();
    for(var k = 0; k < arguments.length; k += 1){
        newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];
        for(var i = 0; i < this.length; i += 1){
            if (typeof newChild === "string") {
                var tempDiv = document.createElement("div");
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(var j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    var document = (0, $6fzuY.getDocument)();
    var i;
    var j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === "string") {
            var tempDiv = document.createElement("div");
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    var before = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(var j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    var after = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(var j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        var _next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(_next).is(selector)) nextEls.push(_next);
        } else nextEls.push(_next);
        el = _next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        var el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        var _prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(_prev).is(selector)) prevEls.push(_prev);
        } else prevEls.push(_prev);
        el = _prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var _parent = this[i].parentNode; // eslint-disable-line
        while(_parent){
            if (selector) {
                if ($(_parent).is(selector)) parents.push(_parent);
            } else parents.push(_parent);
            _parent = _parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === "undefined") return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    var foundElements = [];
    for(var i = 0; i < this.length; i += 1){
        var found = this[i].querySelectorAll(selector);
        for(var j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    var children = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var childNodes = this[i].children;
        for(var j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add() {
    var dom = this;
    var i;
    var j;
    for(var _len10 = arguments.length, els = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++)els[_key10] = arguments[_key10];
    for(i = 0; i < els.length; i += 1){
        var toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.nodeType === 1) {
            for(var j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = "";
        }
    }
    return this;
}
function scrollTo() {
    var window = (0, $6fzuY.getWindow)();
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var left = args[0], top = args[1], duration = args[2], easing = args[3], callback = args[4];
    if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        left = args[0];
        top = args[1];
        duration = args[2];
        callback = args[3];
        easing = args[4];
    }
    if (typeof easing === "undefined") easing = "swing";
    return this.each(function animate() {
        var el = this;
        var currentTop;
        var currentLeft;
        var maxTop;
        var maxLeft;
        var newTop;
        var newLeft;
        var scrollTop; // eslint-disable-line
        var scrollLeft; // eslint-disable-line
        var animateTop = top > 0 || top === 0;
        var animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") easing = "swing";
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        var startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time) {
            if (time === void 0) time = new Date().getTime();
            if (startTime === null) startTime = time;
            var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            var easeProgress = easing === "linear" ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            var done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var top = args[0], duration = args[1], easing = args[2], callback = args[3];
    if (args.length === 3 && typeof easing === "function") {
        top = args[0];
        duration = args[1];
        callback = args[2];
        easing = args[3];
    }
    var dom = this;
    if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    var left = args[0], duration = args[1], easing = args[2], callback = args[3];
    if (args.length === 3 && typeof easing === "function") {
        left = args[0];
        duration = args[1];
        callback = args[2];
        easing = args[3];
    }
    var dom = this;
    if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
function animate(initialProps, initialParams) {
    var window = (0, $6fzuY.getWindow)();
    var els = this;
    var a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: "swing" // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress: function easingProgress(easing, progress) {
            if (easing === "swing") return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === "function") return easing(progress);
            return progress;
        },
        stop: function stop() {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each(function(el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done: function done(complete) {
            a.animating = false;
            a.elements.each(function(el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                var que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate: function animate(props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            var elements = []; // Define & Cache Initials & Units
            a.elements.each(function(el, index) {
                var initialFullValue;
                var initialValue;
                var unit;
                var finalValue;
                var finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach(function(prop) {
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(",", ".");
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, "");
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            var startTime = null;
            var time;
            var elementsDone = 0;
            var propsDone = 0;
            var done;
            var began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                var progress;
                var easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach(function(element) {
                    var el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach(function(prop) {
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        var _el$prop = el[prop], initialValue = _el$prop.initialValue, finalValue = _el$prop.finalValue, unit = _el$prop.unit;
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        var currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    var animateInstance;
    for(var i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === "stop") animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    var els = this;
    for(var i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
var noTrigger = "resize scroll".split(" ");
function shortcut(name) {
    function eventHandler() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "undefined") {
            for(var i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on.apply(this, [
            name
        ].concat(args));
    }
    return eventHandler;
}
var click = shortcut("click");
var blur = shortcut("blur");
var focus = shortcut("focus");
var focusin = shortcut("focusin");
var focusout = shortcut("focusout");
var keyup = shortcut("keyup");
var keydown = shortcut("keydown");
var keypress = shortcut("keypress");
var submit = shortcut("submit");
var change = shortcut("change");
var mousedown = shortcut("mousedown");
var mousemove = shortcut("mousemove");
var mouseup = shortcut("mouseup");
var mouseenter = shortcut("mouseenter");
var mouseleave = shortcut("mouseleave");
var mouseout = shortcut("mouseout");
var mouseover = shortcut("mouseover");
var touchstart = shortcut("touchstart");
var touchend = shortcut("touchend");
var touchmove = shortcut("touchmove");
var resize = shortcut("resize");
var scroll = shortcut("scroll");
var $184888bd8accd961$export$2e2bcd8739ae039 = $;

});


parcelRegister("8Ji4q", function(module, exports) {

$parcel$export(module.exports, "deleteProps", () => $65b08b17e4233fba$export$8694e5c03a4df8e6);
$parcel$export(module.exports, "nextTick", () => $65b08b17e4233fba$export$bdd553fddd433dcb);
$parcel$export(module.exports, "now", () => $65b08b17e4233fba$export$461939dd4422153);
$parcel$export(module.exports, "getTranslate", () => $65b08b17e4233fba$export$5ec402b7fcf74398);
$parcel$export(module.exports, "isObject", () => $65b08b17e4233fba$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "extend", () => $65b08b17e4233fba$export$8b58be045bf06082);
$parcel$export(module.exports, "bindModuleMethods", () => $65b08b17e4233fba$export$d2651194ddf43b70);
$parcel$export(module.exports, "classesToSelector", () => $65b08b17e4233fba$export$730a8e2ed4fdbe02);
$parcel$export(module.exports, "createElementIfNotDefined", () => $65b08b17e4233fba$export$f4bbea1d7959d26b);

var $6fzuY = parcelRequire("6fzuY");
function $65b08b17e4233fba$export$8694e5c03a4df8e6(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $65b08b17e4233fba$export$bdd553fddd433dcb(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $65b08b17e4233fba$export$461939dd4422153() {
    return Date.now();
}
function $65b08b17e4233fba$export$3735103072e4a80(el) {
    var window1 = (0, $6fzuY.getWindow)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $65b08b17e4233fba$export$5ec402b7fcf74398(el, axis) {
    if (axis === void 0) axis = "x";
    var window1 = (0, $6fzuY.getWindow)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = $65b08b17e4233fba$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map(function(a) {
            return a.replace(",", ".");
        }).join(", ");
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $65b08b17e4233fba$export$a6cdc56e425d0d0a(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $65b08b17e4233fba$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $65b08b17e4233fba$export$8b58be045bf06082() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    var noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(var i = 1; i < arguments.length; i += 1){
        var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$65b08b17e4233fba$var$isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($65b08b17e4233fba$export$a6cdc56e425d0d0a(to[nextKey]) && $65b08b17e4233fba$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $65b08b17e4233fba$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$65b08b17e4233fba$export$a6cdc56e425d0d0a(to[nextKey]) && $65b08b17e4233fba$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $65b08b17e4233fba$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $65b08b17e4233fba$export$d2651194ddf43b70(instance, obj) {
    Object.keys(obj).forEach(function(key) {
        if ($65b08b17e4233fba$export$a6cdc56e425d0d0a(obj[key])) Object.keys(obj[key]).forEach(function(subKey) {
            if (typeof obj[key][subKey] === "function") obj[key][subKey] = obj[key][subKey].bind(instance);
        });
        instance[key] = obj[key];
    });
}
function $65b08b17e4233fba$export$730a8e2ed4fdbe02(classes) {
    if (classes === void 0) classes = "";
    return "." + classes.trim().replace(/([\.:!\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".");
}
function $65b08b17e4233fba$export$f4bbea1d7959d26b($container, params, createElements, checkProps) {
    var document = (0, $6fzuY.getDocument)();
    if (createElements) Object.keys(checkProps).forEach(function(key) {
        if (!params[key] && params.auto === true) {
            var element = document.createElement("div");
            element.className = checkProps[key];
            $container.append(element);
            params[key] = element;
        }
    });
    return params;
}

});

parcelRegister("eDC3w", function(module, exports) {

$parcel$export(module.exports, "getSupport", () => $aa823a4772ecf858$export$d61c7b85ff180578);

var $6fzuY = parcelRequire("6fzuY");
var $aa823a4772ecf858$var$support;
function $aa823a4772ecf858$var$calcSupport() {
    var window = (0, $6fzuY.getWindow)();
    var document = (0, $6fzuY.getDocument)();
    return {
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        pointerEvents: !!window.PointerEvent && "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints >= 0,
        observer: function checkObserver() {
            return "MutationObserver" in window || "WebkitMutationObserver" in window;
        }(),
        passiveListener: function checkPassiveListener() {
            var supportsPassive = false;
            try {
                var opts = Object.defineProperty({}, "passive", {
                    // eslint-disable-next-line
                    get: function get() {
                        supportsPassive = true;
                    }
                });
                window.addEventListener("testPassiveListener", null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return "ongesturestart" in window;
        }()
    };
}
function $aa823a4772ecf858$export$d61c7b85ff180578() {
    if (!$aa823a4772ecf858$var$support) $aa823a4772ecf858$var$support = $aa823a4772ecf858$var$calcSupport();
    return $aa823a4772ecf858$var$support;
}

});

parcelRegister("i6q4Z", function(module, exports) {

$parcel$export(module.exports, "getDevice", () => $d2dd0462c44cea02$export$30c823bc834d6ab4);

var $6fzuY = parcelRequire("6fzuY");

var $eDC3w = parcelRequire("eDC3w");
var $d2dd0462c44cea02$var$device;
function $d2dd0462c44cea02$var$calcDevice(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, userAgent = _ref.userAgent;
    var support = (0, $eDC3w.getSupport)();
    var window = (0, $6fzuY.getWindow)();
    var platform = window.navigator.platform;
    var ua = userAgent || window.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === "Win32";
    var macos = platform === "MacIntel"; // iPadOs 13 fix
    var iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    } // Export object
    return device;
}
function $d2dd0462c44cea02$export$30c823bc834d6ab4(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$d2dd0462c44cea02$var$device) $d2dd0462c44cea02$var$device = $d2dd0462c44cea02$var$calcDevice(overrides);
    return $d2dd0462c44cea02$var$device;
}

});

parcelRegister("disVx", function(module, exports) {

$parcel$export(module.exports, "getBrowser", () => $9ae3651ea9093b5e$export$89e15fc796a4a429);

var $6fzuY = parcelRequire("6fzuY");
var $9ae3651ea9093b5e$var$browser;
function $9ae3651ea9093b5e$var$calcBrowser() {
    var window = (0, $6fzuY.getWindow)();
    function isSafari() {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    return {
        isEdge: !!window.navigator.userAgent.match(/Edge/g),
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $9ae3651ea9093b5e$export$89e15fc796a4a429() {
    if (!$9ae3651ea9093b5e$var$browser) $9ae3651ea9093b5e$var$browser = $9ae3651ea9093b5e$var$calcBrowser();
    return $9ae3651ea9093b5e$var$browser;
}

});

parcelRegister("eL251", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe7118059d5f55e$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $8Ji4q = parcelRequire("8Ji4q");
var $abe7118059d5f55e$var$supportsResizeObserver = function supportsResizeObserver() {
    var window = (0, $6fzuY.getWindow)();
    return typeof window.ResizeObserver !== "undefined";
};
var $abe7118059d5f55e$export$2e2bcd8739ae039 = {
    name: "resize",
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.extend)(swiper, {
            resize: {
                observer: null,
                createObserver: function createObserver() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.resize.observer = new ResizeObserver(function(entries) {
                        var width = swiper.width, height = swiper.height;
                        var newWidth = width;
                        var newHeight = height;
                        entries.forEach(function(_ref) {
                            var contentBoxSize = _ref.contentBoxSize, contentRect = _ref.contentRect, target = _ref.target;
                            if (target && target !== swiper.el) return;
                            newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                            newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                        });
                        if (newWidth !== width || newHeight !== height) swiper.resize.resizeHandler();
                    });
                    swiper.resize.observer.observe(swiper.el);
                },
                removeObserver: function removeObserver() {
                    if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
                        swiper.resize.observer.unobserve(swiper.el);
                        swiper.resize.observer = null;
                    }
                },
                resizeHandler: function resizeHandler() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.emit("beforeResize");
                    swiper.emit("resize");
                },
                orientationChangeHandler: function orientationChangeHandler() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.emit("orientationchange");
                }
            }
        });
    },
    on: {
        init: function init(swiper) {
            var window = (0, $6fzuY.getWindow)();
            if (swiper.params.resizeObserver && $abe7118059d5f55e$var$supportsResizeObserver()) {
                swiper.resize.createObserver();
                return;
            } // Emit resize
            window.addEventListener("resize", swiper.resize.resizeHandler); // Emit orientationchange
            window.addEventListener("orientationchange", swiper.resize.orientationChangeHandler);
        },
        destroy: function destroy(swiper) {
            var window = (0, $6fzuY.getWindow)();
            swiper.resize.removeObserver();
            window.removeEventListener("resize", swiper.resize.resizeHandler);
            window.removeEventListener("orientationchange", swiper.resize.orientationChangeHandler);
        }
    }
};

});

parcelRegister("8sY3f", function(module, exports) {

$parcel$export(module.exports, "default", () => $629f8539c7fbc632$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $8Ji4q = parcelRequire("8Ji4q");
function $629f8539c7fbc632$var$_extends() {
    $629f8539c7fbc632$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $629f8539c7fbc632$var$_extends.apply(this, arguments);
}
var $629f8539c7fbc632$var$Observer = {
    attach: function attach(target, options) {
        if (options === void 0) options = {};
        var window = (0, $6fzuY.getWindow)();
        var swiper = this;
        var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                swiper.emit("observerUpdate", mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                swiper.emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        swiper.observer.observers.push(observer);
    },
    init: function init() {
        var swiper = this;
        if (!swiper.support.observer || !swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = swiper.$el.parents();
            for(var i = 0; i < containerParents.length; i += 1)swiper.observer.attach(containerParents[i]);
        } // Observe container
        swiper.observer.attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        swiper.observer.attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    },
    destroy: function destroy() {
        var swiper = this;
        swiper.observer.observers.forEach(function(observer) {
            observer.disconnect();
        });
        swiper.observer.observers = [];
    }
};
var $629f8539c7fbc632$export$2e2bcd8739ae039 = {
    name: "observer",
    params: {
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            observer: $629f8539c7fbc632$var$_extends({}, $629f8539c7fbc632$var$Observer, {
                observers: []
            })
        });
    },
    on: {
        init: function init(swiper) {
            swiper.observer.init();
        },
        destroy: function destroy(swiper) {
            swiper.observer.destroy();
        }
    }
};

});

parcelRegister("aauNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7672baa4c08ec55d$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");
var $7672baa4c08ec55d$export$2e2bcd8739ae039 = {
    useParams: function useParams(instanceParams) {
        var instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach(function(moduleName) {
            var module = instance.modules[moduleName]; // Extend params
            if (module.params) (0, $8Ji4q.extend)(instanceParams, module.params);
        });
    },
    useModules: function useModules(modulesParams) {
        if (modulesParams === void 0) modulesParams = {};
        var instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach(function(moduleName) {
            var module = instance.modules[moduleName];
            var moduleParams = modulesParams[moduleName] || {}; // Add event listeners
            if (module.on && instance.on) Object.keys(module.on).forEach(function(moduleEventName) {
                instance.on(moduleEventName, module.on[moduleEventName]);
            });
             // Module create callback
            if (module.create) module.create.bind(instance)(moduleParams);
        });
    }
};

});

parcelRegister("2ZHgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e2d7f9bf8b31c8$export$2e2bcd8739ae039);
/* eslint-disable no-underscore-dangle */ var $22e2d7f9bf8b31c8$export$2e2bcd8739ae039 = {
    on: function on(events, handler, priority) {
        var self = this;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        events.split(" ").forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function once(events, handler, priority) {
        var self = this;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function onAny(handler, priority) {
        var self = this;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function offAny(handler) {
        var self = this;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function off(events, handler) {
        var self = this;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach(function(event) {
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function emit() {
        var self = this;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat(data));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};

});

parcelRegister("j9FfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $df1edbd43eb22bf4$export$2e2bcd8739ae039);

var $6tWKH = parcelRequire("6tWKH");

var $9KQm9 = parcelRequire("9KQm9");

var $31iSg = parcelRequire("31iSg");

var $kbcNl = parcelRequire("kbcNl");

var $eVNA0 = parcelRequire("eVNA0");

var $erXfo = parcelRequire("erXfo");

var $8KabH = parcelRequire("8KabH");

var $gSL0L = parcelRequire("gSL0L");

var $2bZpP = parcelRequire("2bZpP");
var $df1edbd43eb22bf4$export$2e2bcd8739ae039 = {
    updateSize: (0, $6tWKH.default),
    updateSlides: (0, $9KQm9.default),
    updateAutoHeight: (0, $31iSg.default),
    updateSlidesOffset: (0, $kbcNl.default),
    updateSlidesProgress: (0, $eVNA0.default),
    updateProgress: (0, $erXfo.default),
    updateSlidesClasses: (0, $8KabH.default),
    updateActiveIndex: (0, $gSL0L.default),
    updateClickedSlide: (0, $2bZpP.default)
};

});
parcelRegister("6tWKH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b83067d77cfd073$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");
function $4b83067d77cfd073$export$2e2bcd8739ae039() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
    height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    (0, $8Ji4q.extend)(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}

});

parcelRegister("9KQm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $71a105cb02ee0690$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");
function $71a105cb02ee0690$export$2e2bcd8739ae039() {
    var swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children("." + swiper.params.slideClass);
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: "",
        marginBottom: "",
        marginTop: ""
    });
    else slides.css({
        marginRight: "",
        marginBottom: "",
        marginTop: ""
    });
    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
        if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
        if (params.slidesPerView !== "auto" && params.slidesPerColumnFill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    } // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = slides.eq(i);
        if (params.slidesPerColumn > 1) {
            // Set slides order
            var newSlideOrderIndex = void 0;
            var column = void 0;
            var row = void 0;
            if (params.slidesPerColumnFill === "row" && params.slidesPerGroup > 1) {
                var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
                var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
                var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
                row = Math.floor(slideIndexInGroup / columnsInGroup);
                column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
                newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                slide.css({
                    "-webkit-box-ordinal-group": newSlideOrderIndex,
                    "-moz-box-ordinal-group": newSlideOrderIndex,
                    "-ms-flex-order": newSlideOrderIndex,
                    "-webkit-order": newSlideOrderIndex,
                    order: newSlideOrderIndex
                });
            } else if (params.slidesPerColumnFill === "column") {
                column = Math.floor(i / slidesPerColumn);
                row = i - column * slidesPerColumn;
                if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
                    row += 1;
                    if (row >= slidesPerColumn) {
                        row = 0;
                        column += 1;
                    }
                }
            } else {
                row = Math.floor(i / slidesPerRow);
                column = i - row * slidesPerRow;
            }
            slide.css(getDirectionLabel("margin-top"), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : "");
        }
        if (slide.css("display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            var slideStyles = getComputedStyle(slide[0]);
            var currentTransform = slide[0].style.transform;
            var currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = "none";
            if (currentWebKitTransform) slide[0].style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, "width");
                var paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                var paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                var marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                var marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                var boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    var _slide$ = slide[0], clientWidth = _slide$.clientWidth, offsetWidth = _slide$.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = slideSize + "px";
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) $wrapperEl.css({
        width: swiper.virtualSize + params.spaceBetween + "px"
    });
    if (params.setWrapperSize) {
        var _$wrapperEl$css;
        $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel("width")] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
    }
    if (params.slidesPerColumn > 1) {
        var _$wrapperEl$css2;
        swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
        $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel("width")] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));
        if (params.centeredSlides) {
            newSlidesGrid = [];
            for(var _i = 0; _i < snapGrid.length; _i += 1){
                var slidesGridItem = snapGrid[_i];
                if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid = newSlidesGrid;
        }
    } // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        newSlidesGrid = [];
        for(var _i2 = 0; _i2 < snapGrid.length; _i2 += 1){
            var _slidesGridItem = snapGrid[_i2];
            if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);
            if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(_slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        var _slides$filter$css;
        var key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        var maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(function(snap) {
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var _allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        _allSlidesSize -= params.spaceBetween;
        if (_allSlidesSize < swiperSize) {
            var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    (0, $8Ji4q.extend)(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress || params.watchSlidesVisibility) swiper.updateSlidesOffset();
}

});

parcelRegister("31iSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $23301b224d2f8234$export$2e2bcd8739ae039);
function $23301b224d2f8234$export$2e2bcd8739ae039(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function getSlideByIndex(index) {
        if (isVirtual) return swiper.slides.filter(function(el) {
            return parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index;
        })[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) swiper.visibleSlides.each(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight) swiper.$wrapperEl.css("height", newHeight + "px");
}

});

parcelRegister("kbcNl", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0ec28a59eceb63$export$2e2bcd8739ae039);
function $eb0ec28a59eceb63$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}

});

parcelRegister("eVNA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $adecd91229e4c98e$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");
function $adecd91229e4c98e$export$2e2bcd8739ae039(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
            var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
            var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
            var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
            if (isVisible) {
                swiper.visibleSlides.push(slide);
                swiper.visibleSlidesIndexes.push(i);
                slides.eq(i).addClass(params.slideVisibleClass);
            }
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = (0, $1Lk6P.default)(swiper.visibleSlides);
}

});

parcelRegister("erXfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8518b93f0ba8027$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");
function $a8518b93f0ba8027$export$2e2bcd8739ae039(translate) {
    var swiper = this;
    if (typeof translate === "undefined") {
        var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    (0, $8Ji4q.extend)(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}

});

parcelRegister("8KabH", function(module, exports) {

$parcel$export(module.exports, "default", () => $65da85a9dfac17fe$export$2e2bcd8739ae039);
function $65da85a9dfac17fe$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex, realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
    var activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find("." + params.slideClass + '[data-swiper-slide-index="' + activeIndex + '"]');
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ')[data-swiper-slide-index="' + realIndex + '"]').addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + '[data-swiper-slide-index="' + realIndex + '"]').addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr("data-swiper-slide-index") + '"]').addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr("data-swiper-slide-index") + '"]').addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr("data-swiper-slide-index") + '"]').addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr("data-swiper-slide-index") + '"]').addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}

});

parcelRegister("gSL0L", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4a627f1d4306097$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");
function $c4a627f1d4306097$export$2e2bcd8739ae039(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === "undefined") {
        for(var i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== "undefined") {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    } // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    (0, $8Ji4q.extend)(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}

});

parcelRegister("2bZpP", function(module, exports) {

$parcel$export(module.exports, "default", () => $198c3faf4f06fddd$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");
function $198c3faf4f06fddd$export$2e2bcd8739ae039(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = (0, $1Lk6P.default)(e.target).closest("." + params.slideClass)[0];
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $1Lk6P.default)(slide).attr("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}

});


parcelRegister("fE0Dv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63b15c2bfcc94f1$export$2e2bcd8739ae039);

var $aKMX1 = parcelRequire("aKMX1");

var $zUPly = parcelRequire("zUPly");

var $atSjx = parcelRequire("atSjx");

var $i0bYM = parcelRequire("i0bYM");

var $c460t = parcelRequire("c460t");
var $b63b15c2bfcc94f1$export$2e2bcd8739ae039 = {
    getTranslate: (0, $aKMX1.default),
    setTranslate: (0, $zUPly.default),
    minTranslate: (0, $atSjx.default),
    maxTranslate: (0, $i0bYM.default),
    translateTo: (0, $c460t.default)
};

});
parcelRegister("aKMX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $02053a83d2f923f0$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");
function $02053a83d2f923f0$export$2e2bcd8739ae039(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, $wrapperEl = swiper.$wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, $8Ji4q.getTranslate)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}

});

parcelRegister("zUPly", function(module, exports) {

$parcel$export(module.exports, "default", () => $06bf59b0f93b45e6$export$2e2bcd8739ae039);
function $06bf59b0f93b45e6$export$2e2bcd8739ae039(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, $wrapperEl = swiper.$wrapperEl, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}

});

parcelRegister("atSjx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a16be7d18e83414$export$2e2bcd8739ae039);
function $7a16be7d18e83414$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}

});

parcelRegister("i0bYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b184ecbc7b9bec$export$2e2bcd8739ae039);
function $d1b184ecbc7b9bec$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}

});

parcelRegister("c460t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c8a8489be8b20d5$export$2e2bcd8739ae039);
function $8c8a8489be8b20d5$export$2e2bcd8739ae039(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
            var _wrapperEl$scrollTo;
            wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? "left" : "top"] = -newTranslate, _wrapperEl$scrollTo.behavior = "smooth", _wrapperEl$scrollTo));
        } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}

});


parcelRegister("f99uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b06f0f2183f6b528$export$2e2bcd8739ae039);

var $hNrOw = parcelRequire("hNrOw");

var $dC5E3 = parcelRequire("dC5E3");

var $l6Z33 = parcelRequire("l6Z33");
var $b06f0f2183f6b528$export$2e2bcd8739ae039 = {
    setTransition: (0, $hNrOw.default),
    transitionStart: (0, $dC5E3.default),
    transitionEnd: (0, $l6Z33.default)
};

});
parcelRegister("hNrOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf4c96834a498e7f$export$2e2bcd8739ae039);
function $cf4c96834a498e7f$export$2e2bcd8739ae039(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit("setTransition", duration, byController);
}

});

parcelRegister("dC5E3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e9333fa83ef12f9$export$2e2bcd8739ae039);
function $9e9333fa83ef12f9$export$2e2bcd8739ae039(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var activeIndex = swiper.activeIndex, params = swiper.params, previousIndex = swiper.previousIndex;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transitionStart");
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransitionStart");
            return;
        }
        swiper.emit("slideChangeTransitionStart");
        if (dir === "next") swiper.emit("slideNextTransitionStart");
        else swiper.emit("slidePrevTransitionStart");
    }
}

});

parcelRegister("l6Z33", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5e9836d53dabbec$export$2e2bcd8739ae039);
function $f5e9836d53dabbec$export$2e2bcd8739ae039(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex, params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transitionEnd");
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransitionEnd");
            return;
        }
        swiper.emit("slideChangeTransitionEnd");
        if (dir === "next") swiper.emit("slideNextTransitionEnd");
        else swiper.emit("slidePrevTransitionEnd");
    }
}

});


parcelRegister("72SZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $52135ec523f00b31$export$2e2bcd8739ae039);

var $q07b7 = parcelRequire("q07b7");

var $a3YCl = parcelRequire("a3YCl");

var $kVXeS = parcelRequire("kVXeS");

var $1eond = parcelRequire("1eond");

var $gQPBZ = parcelRequire("gQPBZ");

var $llCn5 = parcelRequire("llCn5");

var $4j3fw = parcelRequire("4j3fw");
var $52135ec523f00b31$export$2e2bcd8739ae039 = {
    slideTo: (0, $q07b7.default),
    slideToLoop: (0, $a3YCl.default),
    slideNext: (0, $kVXeS.default),
    slidePrev: (0, $1eond.default),
    slideReset: (0, $gQPBZ.default),
    slideToClosest: (0, $llCn5.default),
    slideToClickedSlide: (0, $4j3fw.default)
};

});
parcelRegister("q07b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $04e2849d7adeeadc$export$2e2bcd8739ae039);
function $04e2849d7adeeadc$export$2e2bcd8739ae039(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index !== "number" && typeof index !== "string") throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ var indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ var isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    var translate = -snapGrid[snapIndex]; // Update progress
    swiper.updateProgress(translate); // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGird = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGird) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    var direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset"; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = -translate;
        if (rtl) t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
        else // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
            var _wrapperEl$scrollTo;
            wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? "left" : "top"] = t, _wrapperEl$scrollTo.behavior = "smooth", _wrapperEl$scrollTo));
        } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
                swiper.onSlideToWrapperTransitionEnd = null;
                delete swiper.onSlideToWrapperTransitionEnd;
                swiper.transitionEnd(runCallbacks, direction);
            };
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
        }
    }
    return true;
}

});

parcelRegister("a3YCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $75393490a3fa7e9d$export$2e2bcd8739ae039);
function $75393490a3fa7e9d$export$2e2bcd8739ae039(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

});

parcelRegister("kVXeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $03eed2ebfed40b7e$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $03eed2ebfed40b7e$export$2e2bcd8739ae039(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params, animating = swiper.animating, enabled = swiper.enabled;
    if (!enabled) return swiper;
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

});

parcelRegister("1eond", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e5a015151aaf196$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $0e5a015151aaf196$export$2e2bcd8739ae039(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params, animating = swiper.animating, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) snapGrid.forEach(function(snap) {
        if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
    var prevIndex;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

});

parcelRegister("gQPBZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c44989abaefec36d$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $c44989abaefec36d$export$2e2bcd8739ae039(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

});

parcelRegister("llCn5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a952df5f42e11f$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $f8a952df5f42e11f$export$2e2bcd8739ae039(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var _currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}

});

parcelRegister("4j3fw", function(module, exports) {

$parcel$export(module.exports, "default", () => $322b7506fd92a997$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $322b7506fd92a997$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl;
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $1Lk6P.default)(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children("." + params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + params.slideDuplicateClass + ")").eq(0).index();
                (0, $8Ji4q.nextTick)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children("." + params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + params.slideDuplicateClass + ")").eq(0).index();
            (0, $8Ji4q.nextTick)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}

});


parcelRegister("4HlIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $36bc05a738ea62c7$export$2e2bcd8739ae039);

var $ilfhi = parcelRequire("ilfhi");

var $lVxeq = parcelRequire("lVxeq");

var $8v4mY = parcelRequire("8v4mY");
var $36bc05a738ea62c7$export$2e2bcd8739ae039 = {
    loopCreate: (0, $ilfhi.default),
    loopFix: (0, $lVxeq.default),
    loopDestroy: (0, $8v4mY.default)
};

});
parcelRegister("ilfhi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5a60a05ad0855dc$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");
function $d5a60a05ad0855dc$export$2e2bcd8739ae039() {
    var swiper = this;
    var document = (0, $6fzuY.getDocument)();
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides
    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
    var slides = $wrapperEl.children("." + params.slideClass);
    if (params.loopFillGroupWithBlank) {
        var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(var i = 0; i < blankSlidesNum; i += 1){
                var blankNode = (0, $1Lk6P.default)(document.createElement("div")).addClass(params.slideClass + " " + params.slideBlankClass);
                $wrapperEl.append(blankNode);
            }
            slides = $wrapperEl.children("." + params.slideClass);
        }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) swiper.loopedSlides = slides.length;
    var prependSlides = [];
    var appendSlides = [];
    slides.each(function(el, index) {
        var slide = (0, $1Lk6P.default)(el);
        if (index < swiper.loopedSlides) appendSlides.push(el);
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
        slide.attr("data-swiper-slide-index", index);
    });
    for(var _i = 0; _i < appendSlides.length; _i += 1)$wrapperEl.append((0, $1Lk6P.default)(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1)$wrapperEl.prepend((0, $1Lk6P.default)(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
}

});

parcelRegister("lVxeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff68b2fa1604946a$export$2e2bcd8739ae039);
function $ff68b2fa1604946a$export$2e2bcd8739ae039() {
    var swiper = this;
    swiper.emit("beforeLoopFix");
    var activeIndex = swiper.activeIndex, slides = swiper.slides, loopedSlides = swiper.loopedSlides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, snapGrid = swiper.snapGrid, rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        var slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (_slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
}

});

parcelRegister("8v4mY", function(module, exports) {

$parcel$export(module.exports, "default", () => $63049baafed4a6e8$export$2e2bcd8739ae039);
function $63049baafed4a6e8$export$2e2bcd8739ae039() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, slides = swiper.slides;
    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
    slides.removeAttr("data-swiper-slide-index");
}

});


parcelRegister("dgcSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a76c2f07e2413d4$export$2e2bcd8739ae039);

var $aOgkp = parcelRequire("aOgkp");

var $5Ix7y = parcelRequire("5Ix7y");
var $9a76c2f07e2413d4$export$2e2bcd8739ae039 = {
    setGrabCursor: (0, $aOgkp.default),
    unsetGrabCursor: (0, $5Ix7y.default)
};

});
parcelRegister("aOgkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deb3d59345ab04c$export$2e2bcd8739ae039);
function $7deb3d59345ab04c$export$2e2bcd8739ae039(moving) {
    var swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.el;
    el.style.cursor = "move";
    el.style.cursor = moving ? "-webkit-grabbing" : "-webkit-grab";
    el.style.cursor = moving ? "-moz-grabbin" : "-moz-grab";
    el.style.cursor = moving ? "grabbing" : "grab";
}

});

parcelRegister("5Ix7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $429ac0eb3d206b42$export$2e2bcd8739ae039);
function $429ac0eb3d206b42$export$2e2bcd8739ae039() {
    var swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper.el.style.cursor = "";
}

});


parcelRegister("gNU39", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3bcb34097eaaa63$export$2e2bcd8739ae039);

var $h0nhi = parcelRequire("h0nhi");

var $1QfWY = parcelRequire("1QfWY");

var $5iPYw = parcelRequire("5iPYw");

var $kBIXf = parcelRequire("kBIXf");

var $7Qy1K = parcelRequire("7Qy1K");
var $c3bcb34097eaaa63$export$2e2bcd8739ae039 = {
    appendSlide: (0, $h0nhi.default),
    prependSlide: (0, $1QfWY.default),
    addSlide: (0, $5iPYw.default),
    removeSlide: (0, $kBIXf.default),
    removeAllSlides: (0, $7Qy1K.default)
};

});
parcelRegister("h0nhi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6147e496bad3ad5$export$2e2bcd8739ae039);
function $c6147e496bad3ad5$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
}

});

parcelRegister("1QfWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $15770525f1a5615e$export$2e2bcd8739ae039);
function $15770525f1a5615e$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("5iPYw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc6f35e4507a136$export$2e2bcd8739ae039);
function $3dc6f35e4507a136$export$2e2bcd8739ae039(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(var _i = 0; _i < slides.length; _i += 1)if (slides[_i]) $wrapperEl.append(slides[_i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1)$wrapperEl.append(slidesBuffer[_i2]);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("kBIXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f00a226831c3ed68$export$2e2bcd8739ae039);
function $f00a226831c3ed68$export$2e2bcd8739ae039(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("7Qy1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b67c8d6807d5507$export$2e2bcd8739ae039);
function $5b67c8d6807d5507$export$2e2bcd8739ae039() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}

});


parcelRegister("cV85Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $968116801f9e7d60$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $lNtjD = parcelRequire("lNtjD");

var $dpt6x = parcelRequire("dpt6x");

var $5hdeC = parcelRequire("5hdeC");

var $cvR4o = parcelRequire("cvR4o");

var $9UhJp = parcelRequire("9UhJp");

var $2c6gv = parcelRequire("2c6gv");
var $968116801f9e7d60$var$dummyEventAttached = false;
function $968116801f9e7d60$var$dummyEventListener() {}
function $968116801f9e7d60$var$attachEvents() {
    var swiper = this;
    var document = (0, $6fzuY.getDocument)();
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device, support = swiper.support;
    swiper.onTouchStart = (0, $lNtjD.default).bind(swiper);
    swiper.onTouchMove = (0, $dpt6x.default).bind(swiper);
    swiper.onTouchEnd = (0, $5hdeC.default).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $2c6gv.default).bind(swiper);
    swiper.onClick = (0, $9UhJp.default).bind(swiper);
    var capture = !!params.nested; // Touch Events
    if (!support.touch && support.pointerEvents) {
        el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
        if (support.touch) {
            var passiveListener = touchEvents.start === "touchstart" && support.passiveListener && params.passiveListeners ? {
                passive: true,
                capture: false
            } : false;
            el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
                passive: false,
                capture: capture
            } : capture);
            el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
            if (touchEvents.cancel) el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
            if (!$968116801f9e7d60$var$dummyEventAttached) {
                document.addEventListener("touchstart", $968116801f9e7d60$var$dummyEventListener);
                $968116801f9e7d60$var$dummyEventAttached = true;
            }
        }
        if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
            el.addEventListener("mousedown", swiper.onTouchStart, false);
            document.addEventListener("mousemove", swiper.onTouchMove, capture);
            document.addEventListener("mouseup", swiper.onTouchEnd, false);
        }
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el.addEventListener("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl.addEventListener("scroll", swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper.on(device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $cvR4o.default), true);
    else swiper.on("observerUpdate", (0, $cvR4o.default), true);
}
function $968116801f9e7d60$var$detachEvents() {
    var swiper = this;
    var document = (0, $6fzuY.getDocument)();
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device, support = swiper.support;
    var capture = !!params.nested; // Touch Events
    if (!support.touch && support.pointerEvents) {
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
        if (support.touch) {
            var passiveListener = touchEvents.start === "onTouchStart" && support.passiveListener && params.passiveListeners ? {
                passive: true,
                capture: false
            } : false;
            el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
            el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
            if (touchEvents.cancel) el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
        if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
            el.removeEventListener("mousedown", swiper.onTouchStart, false);
            document.removeEventListener("mousemove", swiper.onTouchMove, capture);
            document.removeEventListener("mouseup", swiper.onTouchEnd, false);
        }
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el.removeEventListener("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl.removeEventListener("scroll", swiper.onScroll);
     // Resize handler
    swiper.off(device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $cvR4o.default));
}
var $968116801f9e7d60$export$2e2bcd8739ae039 = {
    attachEvents: $968116801f9e7d60$var$attachEvents,
    detachEvents: $968116801f9e7d60$var$detachEvents
};

});
parcelRegister("lNtjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fde4ea10aa934f7d$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $fde4ea10aa934f7d$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $6fzuY.getDocument)() || el === (0, $6fzuY.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $fde4ea10aa934f7d$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var document = (0, $6fzuY.getDocument)();
    var window = (0, $6fzuY.getWindow)();
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var $targetEl = (0, $1Lk6P.default)(e.target);
    if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === "touchstart";
    if (!data.isTouchEvent && "which" in e && e.which === 3) return;
    if (!data.isTouchEvent && "button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) $targetEl = (0, $1Lk6P.default)(event.path[0]);
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
    var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $fde4ea10aa934f7d$var$closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    (0, $8Ji4q.extend)(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $8Ji4q.now)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== "touchstart") {
        var preventDefault = true;
        if ($targetEl.is(data.focusableElements)) preventDefault = false;
        if (document.activeElement && (0, $1Lk6P.default)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    swiper.emit("touchStart", e);
}

});

parcelRegister("dpt6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c342fb445cf5d06$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $9c342fb445cf5d06$export$2e2bcd8739ae039(event) {
    var document = (0, $6fzuY.getDocument)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    if (data.isTouchEvent && e.type !== "touchmove") return;
    var targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
    var pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (data.isTouched) {
            (0, $8Ji4q.extend)(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $8Ji4q.now)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $1Lk6P.default)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $8Ji4q.now)()
        });
    } // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}

});

parcelRegister("5hdeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d78ce71b2c3c79d$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");
function $3d78ce71b2c3c79d$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, $wrapperEl = swiper.$wrapperEl, slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid, enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    var touchEndTime = (0, $8Ji4q.now)();
    var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        swiper.updateClickedSlide(e);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $8Ji4q.now)();
    (0, $8Ji4q.nextTick)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode) {
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeModeMomentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $8Ji4q.now)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeModeMomentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeModeMomentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeModeMomentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeModeMomentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeModeSticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) swiper.once("transitionEnd", function() {
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeModeSticky) {
                    // If freeModeSticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeModeSticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeModeMomentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    swiper.emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else {
                swiper.emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
            }
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeModeSticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) swiper.emit("_freeModeNoMomentumRelease");
        if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        return;
    } // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + _increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + _increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    } // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}

});

parcelRegister("cvR4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $91c18bd47471df22$export$2e2bcd8739ae039);
function $91c18bd47471df22$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}

});

parcelRegister("9UhJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7367191551b19336$export$2e2bcd8739ae039);
function $7367191551b19336$export$2e2bcd8739ae039(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}

});

parcelRegister("2c6gv", function(module, exports) {

$parcel$export(module.exports, "default", () => $19918fe31d8e3375$export$2e2bcd8739ae039);
function $19918fe31d8e3375$export$2e2bcd8739ae039() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) {
        if (rtlTranslate) swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
        else swiper.translate = -wrapperEl.scrollLeft;
    } else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}

});


parcelRegister("34o6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $23c471a664f1678c$export$2e2bcd8739ae039);

var $k5Lq1 = parcelRequire("k5Lq1");

var $75e1T = parcelRequire("75e1T");
var $23c471a664f1678c$export$2e2bcd8739ae039 = {
    setBreakpoint: (0, $k5Lq1.default),
    getBreakpoint: (0, $75e1T.default)
};

});
parcelRegister("k5Lq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea090ea9d63e87e0$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");
function $ea090ea9d63e87e0$export$2e2bcd8739ae039() {
    var swiper = this;
    var activeIndex = swiper.activeIndex, initialized = swiper.initialized, _swiper$loopedSlides = swiper.loopedSlides, loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides, params = swiper.params, $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    if (breakpointOnlyParams) [
        "slidesPerView",
        "spaceBetween",
        "slidesPerGroup",
        "slidesPerGroupSkip",
        "slidesPerColumn"
    ].forEach(function(param) {
        var paramValue = breakpointOnlyParams[param];
        if (typeof paramValue === "undefined") return;
        if (param === "slidesPerView" && (paramValue === "AUTO" || paramValue === "auto")) breakpointOnlyParams[param] = "auto";
        else if (param === "slidesPerView") breakpointOnlyParams[param] = parseFloat(paramValue);
        else breakpointOnlyParams[param] = parseInt(paramValue, 10);
    });
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = params.slidesPerColumn > 1;
    var isMultiRow = breakpointParams.slidesPerColumn > 1;
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(params.containerModifierClass + "multirow");
        if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === "column" || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === "column") $el.addClass(params.containerModifierClass + "multirow-column");
        swiper.emitContainerClasses();
    }
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $8Ji4q.extend)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    (0, $8Ji4q.extend)(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit("breakpoint", breakpointParams);
}

});

parcelRegister("75e1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $5283e1fe9cdc645c$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");
function $5283e1fe9cdc645c$export$2e2bcd8739ae039(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    var breakpoint = false;
    var window = (0, $6fzuY.getWindow)();
    var currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === "string" && point.indexOf("@") === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points$i = points[i], point = _points$i.point, value = _points$i.value;
        if (base === "window") {
            if (window.matchMedia("(min-width: " + value + "px)").matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}

});


parcelRegister("8njGS", function(module, exports) {

$parcel$export(module.exports, "default", () => $618fbed2b2bc3e4f$export$2e2bcd8739ae039);

var $6ZKgV = parcelRequire("6ZKgV");

var $edaz9 = parcelRequire("edaz9");
var $618fbed2b2bc3e4f$export$2e2bcd8739ae039 = {
    addClasses: (0, $6ZKgV.default),
    removeClasses: (0, $edaz9.default)
};

});
parcelRegister("6ZKgV", function(module, exports) {

$parcel$export(module.exports, "default", () => $517c55373e532399$export$2e2bcd8739ae039);
function $517c55373e532399$var$prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if (typeof item === "object") Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $517c55373e532399$export$2e2bcd8739ae039() {
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, $el = swiper.$el, device = swiper.device, support = swiper.support; // prettier-ignore
    var suffixes = $517c55373e532399$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "pointer-events": support.pointerEvents && !support.touch
        },
        {
            "free-mode": params.freeMode
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "multirow": params.slidesPerColumn > 1
        },
        {
            "multirow-column": params.slidesPerColumn > 1 && params.slidesPerColumnFill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        }
    ], params.containerModifierClass);
    classNames.push.apply(classNames, suffixes);
    $el.addClass([].concat(classNames).join(" "));
    swiper.emitContainerClasses();
}

});

parcelRegister("edaz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58a79c0cb97fc17$export$2e2bcd8739ae039);
function $a58a79c0cb97fc17$export$2e2bcd8739ae039() {
    var swiper = this;
    var $el = swiper.$el, classNames = swiper.classNames;
    $el.removeClass(classNames.join(" "));
    swiper.emitContainerClasses();
}

});


parcelRegister("9aGma", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ad5e75c85ed3c7d$export$2e2bcd8739ae039);

var $9lTrX = parcelRequire("9lTrX");

var $ggYYN = parcelRequire("ggYYN");
var $6ad5e75c85ed3c7d$export$2e2bcd8739ae039 = {
    loadImage: (0, $9lTrX.default),
    preloadImages: (0, $ggYYN.default)
};

});
parcelRegister("9lTrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf11665beff57df$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");
function $6cf11665beff57df$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var window = (0, $6fzuY.getWindow)();
    var image;
    function onReady() {
        if (callback) callback();
    }
    var isPicture = (0, $1Lk6P.default)(imageEl).parent("picture")[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}

});

parcelRegister("ggYYN", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8d713dc60710a1$export$2e2bcd8739ae039);
function $bd8d713dc60710a1$export$2e2bcd8739ae039() {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    function onReady() {
        if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit("imagesReady");
        }
    }
    for(var i = 0; i < swiper.imagesToLoad.length; i += 1){
        var imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
}

});


parcelRegister("hTnVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d06a22e1cc944f4c$export$2e2bcd8739ae039);
function $d06a22e1cc944f4c$var$checkOverflow() {
    var swiper = this;
    var params = swiper.params;
    var wasLocked = swiper.isLocked;
    var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;
    if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) swiper.isLocked = lastSlidePosition <= swiper.size;
    else swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked; // events
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
    if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
        if (swiper.navigation) swiper.navigation.update();
    }
}
var $d06a22e1cc944f4c$export$2e2bcd8739ae039 = {
    checkOverflow: $d06a22e1cc944f4c$var$checkOverflow
};

});

parcelRegister("9xsLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f1d8339c620576f$export$2e2bcd8739ae039);
var $6f1d8339c620576f$export$2e2bcd8739ae039 = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "container",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: false,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: "column",
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: "swiper-container-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};

});


parcelRegister("80uky", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d45d9d34a122ee8$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $5d45d9d34a122ee8$var$_extends() {
    $5d45d9d34a122ee8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5d45d9d34a122ee8$var$_extends.apply(this, arguments);
}
var $5d45d9d34a122ee8$var$Virtual = {
    update: function update(force) {
        var swiper = this;
        var _swiper$params = swiper.params, slidesPerView = _swiper$params.slidesPerView, slidesPerGroup = _swiper$params.slidesPerGroup, centeredSlides = _swiper$params.centeredSlides;
        var _swiper$params$virtua = swiper.params.virtual, addSlidesBefore = _swiper$params$virtua.addSlidesBefore, addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
        var _swiper$virtual = swiper.virtual, previousFrom = _swiper$virtual.from, previousTo = _swiper$virtual.to, slides = _swiper$virtual.slides, previousSlidesGrid = _swiper$virtual.slidesGrid, renderSlide = _swiper$virtual.renderSlide, previousOffset = _swiper$virtual.offset;
        swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        var from = Math.max((activeIndex || 0) - slidesBefore, 0);
        var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        (0, $8Ji4q.extend)(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, offset + "px");
            swiper.updateProgress();
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        if (force) swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
        else {
            for(var i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find("." + swiper.params.slideClass + '[data-swiper-slide-index="' + i + '"]').remove();
        }
        for(var _i = 0; _i < slides.length; _i += 1)if (_i >= from && _i <= to) {
            if (typeof previousTo === "undefined" || force) appendIndexes.push(_i);
            else {
                if (_i > previousTo) appendIndexes.push(_i);
                if (_i < previousFrom) prependIndexes.push(_i);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort(function(a, b) {
            return b - a;
        }).forEach(function(index) {
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children(".swiper-slide").css(offsetProp, offset + "px");
        onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
        var swiper = this;
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        var $slideEl = params.renderSlide ? (0, $1Lk6P.default)(params.renderSlide.call(swiper, slide, index)) : (0, $1Lk6P.default)('<div class="' + swiper.params.slideClass + '" data-swiper-slide-index="' + index + '">' + slide + "</div>");
        if (!$slideEl.attr("data-swiper-slide-index")) $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
        var swiper = this;
        if (typeof slides === "object" && "length" in slides) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
        var swiper = this;
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var $cachedEl = cache[cachedIndex];
                var cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
                if (cachedElIndex) $cachedEl.attr("data-swiper-slide-index", parseInt(cachedElIndex, 10) + 1);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        swiper.virtual.update(true);
        swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
        var swiper = this;
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        swiper.virtual.update(true);
        swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
        var swiper = this;
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        swiper.virtual.update(true);
        swiper.slideTo(0, 0);
    }
};
var $5d45d9d34a122ee8$export$2e2bcd8739ae039 = {
    name: "virtual",
    params: {
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            virtual: $5d45d9d34a122ee8$var$_extends({}, $5d45d9d34a122ee8$var$Virtual, {
                slides: swiper.params.virtual.slides,
                cache: {}
            })
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (!swiper.params.virtual.enabled) return;
            swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
            var overwriteParams = {
                watchSlidesProgress: true
            };
            (0, $8Ji4q.extend)(swiper.params, overwriteParams);
            (0, $8Ji4q.extend)(swiper.originalParams, overwriteParams);
            if (!swiper.params.initialSlide) swiper.virtual.update();
        },
        setTranslate: function setTranslate(swiper) {
            if (!swiper.params.virtual.enabled) return;
            swiper.virtual.update();
        }
    }
};

});

parcelRegister("aRqkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e83468c0b3fac8f$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $7e83468c0b3fac8f$var$_extends() {
    $7e83468c0b3fac8f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7e83468c0b3fac8f$var$_extends.apply(this, arguments);
}
var $7e83468c0b3fac8f$var$Keyboard = {
    handle: function handle(event) {
        var swiper = this;
        if (!swiper.enabled) return;
        var window = (0, $6fzuY.getWindow)();
        var document = (0, $6fzuY.getDocument)();
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents("." + swiper.params.slideClass).length > 0 && swiper.$el.parents("." + swiper.params.slideActiveClass).length === 0) return undefined;
            var $el = swiper.$el;
            var swiperWidth = $el[0].clientWidth;
            var swiperHeight = $el[0].clientHeight;
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        swiper.emit("keyPress", kc);
        return undefined;
    },
    enable: function enable() {
        var swiper = this;
        var document = (0, $6fzuY.getDocument)();
        if (swiper.keyboard.enabled) return;
        (0, $1Lk6P.default)(document).on("keydown", swiper.keyboard.handle);
        swiper.keyboard.enabled = true;
    },
    disable: function disable() {
        var swiper = this;
        var document = (0, $6fzuY.getDocument)();
        if (!swiper.keyboard.enabled) return;
        (0, $1Lk6P.default)(document).off("keydown", swiper.keyboard.handle);
        swiper.keyboard.enabled = false;
    }
};
var $7e83468c0b3fac8f$export$2e2bcd8739ae039 = {
    name: "keyboard",
    params: {
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            keyboard: $7e83468c0b3fac8f$var$_extends({
                enabled: false
            }, $7e83468c0b3fac8f$var$Keyboard)
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.keyboard.enabled) swiper.keyboard.enable();
        },
        destroy: function destroy(swiper) {
            if (swiper.keyboard.enabled) swiper.keyboard.disable();
        }
    }
};

});

parcelRegister("gIciZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2aa4cf9d2440855$export$2e2bcd8739ae039);
/* eslint-disable consistent-return */ 
var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $c2aa4cf9d2440855$var$isEventSupported() {
    var document = (0, $6fzuY.getDocument)();
    var eventName = "onwheel";
    var isSupported = eventName in document;
    if (!isSupported) {
        var element = document.createElement("div");
        element.setAttribute(eventName, "return;");
        isSupported = typeof element[eventName] === "function";
    }
    if (!isSupported && document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    document.implementation.hasFeature("", "") !== true) // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature("Events.wheel", "3.0");
    return isSupported;
}
var $c2aa4cf9d2440855$var$Mousewheel = {
    lastScrollTime: (0, $8Ji4q.now)(),
    lastEventBeforeSnap: undefined,
    recentWheelEvents: [],
    event: function event() {
        var window = (0, $6fzuY.getWindow)();
        if (window.navigator.userAgent.indexOf("firefox") > -1) return "DOMMouseScroll";
        return $c2aa4cf9d2440855$var$isEventSupported() ? "wheel" : "mousewheel";
    },
    normalize: function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    },
    handleMouseEnter: function handleMouseEnter() {
        var swiper = this;
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
        var swiper = this;
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    },
    handle: function handle(event) {
        var e = event;
        var disableParentSwiper = true;
        var swiper = this;
        if (!swiper.enabled) return;
        var params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $1Lk6P.default)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = $c2aa4cf9d2440855$var$Mousewheel.normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        var positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: (0, $8Ji4q.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event
            }; // Keep the most recent events
            var recentWheelEvents = swiper.mousewheel.recentWheelEvents;
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) swiper.mousewheel.animateSlider(newEvent);
            } else swiper.mousewheel.animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (swiper.mousewheel.releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            var _newEvent = {
                time: (0, $8Ji4q.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var lastEventBeforeSnap = swiper.mousewheel.lastEventBeforeSnap;
            var ignoreWheelEvents = lastEventBeforeSnap && _newEvent.time < lastEventBeforeSnap.time + 500 && _newEvent.delta <= lastEventBeforeSnap.delta && _newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                swiper.mousewheel.lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                var position = swiper.getTranslate() + delta * params.sensitivity;
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeModeSticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(swiper.mousewheel.timeout);
                    swiper.mousewheel.timeout = undefined;
                    var _recentWheelEvents = swiper.mousewheel.recentWheelEvents;
                    if (_recentWheelEvents.length >= 15) _recentWheelEvents.shift(); // only store the last N events
                    var _prevEvent = _recentWheelEvents.length ? _recentWheelEvents[_recentWheelEvents.length - 1] : undefined;
                    var firstEvent = _recentWheelEvents[0];
                    _recentWheelEvents.push(_newEvent);
                    if (_prevEvent && (_newEvent.delta > _prevEvent.delta || _newEvent.direction !== _prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    _recentWheelEvents.splice(0);
                    else if (_recentWheelEvents.length >= 15 && _newEvent.time - firstEvent.time < 500 && firstEvent.delta - _newEvent.delta >= 1 && _newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        swiper.mousewheel.lastEventBeforeSnap = _newEvent;
                        _recentWheelEvents.splice(0);
                        swiper.mousewheel.timeout = (0, $8Ji4q.nextTick)(function() {
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!swiper.mousewheel.timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    swiper.mousewheel.timeout = (0, $8Ji4q.nextTick)(function() {
                        var snapToThreshold = 0.5;
                        swiper.mousewheel.lastEventBeforeSnap = _newEvent;
                        _recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) swiper.emit("scroll", e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    },
    animateSlider: function animateSlider(newEvent) {
        var swiper = this;
        var window = (0, $6fzuY.getWindow)();
        if (this.params.mousewheel.thresholdDelta && newEvent.delta < this.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (this.params.mousewheel.thresholdTime && (0, $8Ji4q.now)() - swiper.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $8Ji4q.now)() - swiper.mousewheel.lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                swiper.emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            swiper.emit("scroll", newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        swiper.mousewheel.lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    },
    releaseScroll: function releaseScroll(newEvent) {
        var swiper = this;
        var params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    },
    enable: function enable() {
        var swiper = this;
        var event = $c2aa4cf9d2440855$var$Mousewheel.event();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
            return true;
        }
        if (!event) return false;
        if (swiper.mousewheel.enabled) return false;
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $1Lk6P.default)(swiper.params.mousewheel.eventsTarget);
        target.on("mouseenter", swiper.mousewheel.handleMouseEnter);
        target.on("mouseleave", swiper.mousewheel.handleMouseLeave);
        target.on(event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = true;
        return true;
    },
    disable: function disable() {
        var swiper = this;
        var event = $c2aa4cf9d2440855$var$Mousewheel.event();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
            return true;
        }
        if (!event) return false;
        if (!swiper.mousewheel.enabled) return false;
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $1Lk6P.default)(swiper.params.mousewheel.eventsTarget);
        target.off(event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = false;
        return true;
    }
};
var $c2aa4cf9d2440855$export$2e2bcd8739ae039 = {
    name: "mousewheel",
    params: {
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            mousewheel: {
                enabled: false,
                lastScrollTime: (0, $8Ji4q.now)(),
                lastEventBeforeSnap: undefined,
                recentWheelEvents: [],
                enable: $c2aa4cf9d2440855$var$Mousewheel.enable,
                disable: $c2aa4cf9d2440855$var$Mousewheel.disable,
                handle: $c2aa4cf9d2440855$var$Mousewheel.handle,
                handleMouseEnter: $c2aa4cf9d2440855$var$Mousewheel.handleMouseEnter,
                handleMouseLeave: $c2aa4cf9d2440855$var$Mousewheel.handleMouseLeave,
                animateSlider: $c2aa4cf9d2440855$var$Mousewheel.animateSlider,
                releaseScroll: $c2aa4cf9d2440855$var$Mousewheel.releaseScroll
            }
        });
    },
    on: {
        init: function init(swiper) {
            if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) swiper.mousewheel.disable();
            if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
        },
        destroy: function destroy(swiper) {
            if (swiper.params.cssMode) swiper.mousewheel.enable();
            if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
        }
    }
};

});

parcelRegister("egtsK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a62969fbe7901ab3$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $a62969fbe7901ab3$var$_extends() {
    $a62969fbe7901ab3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a62969fbe7901ab3$var$_extends.apply(this, arguments);
}
var $a62969fbe7901ab3$var$Navigation = {
    toggleEl: function toggleEl($el, disabled) {
        $el[disabled ? "addClass" : "removeClass"](this.params.navigation.disabledClass);
        if ($el[0] && $el[0].tagName === "BUTTON") $el[0].disabled = disabled;
    },
    update: function update() {
        // Update Navigation Buttons
        var swiper = this;
        var params = swiper.params.navigation;
        var toggleEl = swiper.navigation.toggleEl;
        if (swiper.params.loop) return;
        var _swiper$navigation = swiper.navigation, $nextEl = _swiper$navigation.$nextEl, $prevEl = _swiper$navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) toggleEl($prevEl, true);
            else toggleEl($prevEl, false);
            if (swiper.params.watchOverflow && swiper.enabled) $prevEl[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) toggleEl($nextEl, true);
            else toggleEl($nextEl, false);
            if (swiper.params.watchOverflow && swiper.enabled) $nextEl[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
    },
    onPrevClick: function onPrevClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop) return;
        swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop) return;
        swiper.slideNext();
    },
    init: function init() {
        var swiper = this;
        var params = swiper.params.navigation;
        swiper.params.navigation = (0, $8Ji4q.createElementIfNotDefined)(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        var $nextEl;
        var $prevEl;
        if (params.nextEl) {
            $nextEl = (0, $1Lk6P.default)(params.nextEl);
            if (swiper.params.uniqueNavElements && typeof params.nextEl === "string" && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) $nextEl = swiper.$el.find(params.nextEl);
        }
        if (params.prevEl) {
            $prevEl = (0, $1Lk6P.default)(params.prevEl);
            if (swiper.params.uniqueNavElements && typeof params.prevEl === "string" && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) $prevEl = swiper.$el.find(params.prevEl);
        }
        if ($nextEl && $nextEl.length > 0) $nextEl.on("click", swiper.navigation.onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on("click", swiper.navigation.onPrevClick);
        (0, $8Ji4q.extend)(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    },
    destroy: function destroy() {
        var swiper = this;
        var _swiper$navigation2 = swiper.navigation, $nextEl = _swiper$navigation2.$nextEl, $prevEl = _swiper$navigation2.$prevEl;
        if ($nextEl && $nextEl.length) {
            $nextEl.off("click", swiper.navigation.onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off("click", swiper.navigation.onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
};
var $a62969fbe7901ab3$export$2e2bcd8739ae039 = {
    name: "navigation",
    params: {
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock"
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            navigation: $a62969fbe7901ab3$var$_extends({}, $a62969fbe7901ab3$var$Navigation)
        });
    },
    on: {
        init: function init(swiper) {
            swiper.navigation.init();
            swiper.navigation.update();
        },
        toEdge: function toEdge(swiper) {
            swiper.navigation.update();
        },
        fromEdge: function fromEdge(swiper) {
            swiper.navigation.update();
        },
        destroy: function destroy(swiper) {
            swiper.navigation.destroy();
        },
        "enable disable": function enableDisable(swiper) {
            var _swiper$navigation3 = swiper.navigation, $nextEl = _swiper$navigation3.$nextEl, $prevEl = _swiper$navigation3.$prevEl;
            if ($nextEl) $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
            if ($prevEl) $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
        },
        click: function click(swiper, e) {
            var _swiper$navigation4 = swiper.navigation, $nextEl = _swiper$navigation4.$nextEl, $prevEl = _swiper$navigation4.$prevEl;
            var targetEl = e.target;
            if (swiper.params.navigation.hideOnClick && !(0, $1Lk6P.default)(targetEl).is($prevEl) && !(0, $1Lk6P.default)(targetEl).is($nextEl)) {
                if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
                var isHidden;
                if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
                else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
                if (isHidden === true) swiper.emit("navigationShow");
                else swiper.emit("navigationHide");
                if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
                if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
        }
    }
};

});

parcelRegister("9FVzM", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b49acd42116838$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $70b49acd42116838$var$_extends() {
    $70b49acd42116838$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70b49acd42116838$var$_extends.apply(this, arguments);
}
var $70b49acd42116838$var$Pagination = {
    update: function update() {
        // Render || Update Pagination bullets/items
        var swiper = this;
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el; // Current/Total
        var current;
        var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
                $el.css(swiper.isHorizontal() ? "width" : "height", swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
                    if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (swiper.pagination.dynamicBulletIndex < 0) swiper.pagination.dynamicBulletIndex = 0;
                }
                firstIndex = current - swiper.pagination.dynamicBulletIndex;
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");
            if ($el.length > 1) bullets.each(function(bullet) {
                var $bullet = (0, $1Lk6P.default)(bullet);
                var bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(params.bulletActiveClass + "-main");
                    if (bulletIndex === firstIndex) $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                    if (bulletIndex === lastIndex) $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                }
            });
            else {
                var $bullet = bullets.eq(current);
                var bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    var $firstDisplayedBullet = bullets.eq(firstIndex);
                    var $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(var i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(params.bulletActiveClass + "-main");
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                            for(var _i = params.dynamicMainBullets; _i >= 0; _i -= 1)bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
                        } else {
                            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                        }
                    } else {
                        $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                        $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                    }
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
                var offsetProp = rtl ? "right" : "left";
                bullets.css(swiper.isHorizontal() ? offsetProp : "top", bulletsOffset + "px");
            }
        }
        if (params.type === "fraction") {
            $el.find((0, $8Ji4q.classesToSelector)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $8Ji4q.classesToSelector)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
            var progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
            else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
            var scale = (current + 1) / total;
            var scaleX = 1;
            var scaleY = 1;
            if (progressbarDirection === "horizontal") scaleX = scale;
            else scaleY = scale;
            $el.find((0, $8Ji4q.classesToSelector)(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            swiper.emit("paginationRender", $el[0]);
        } else swiper.emit("paginationUpdate", $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    },
    render: function render() {
        // Render Container
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        var paginationHTML = "";
        if (params.type === "bullets") {
            var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += "<" + params.bulletElement + ' class="' + params.bulletClass + '"></' + params.bulletElement + ">";
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $8Ji4q.classesToSelector)(params.bulletClass));
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = '<span class="' + params.currentClass + '"></span>' + " / " + ('<span class="' + params.totalClass + '"></span>');
            $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = '<span class="' + params.progressbarFillClass + '"></span>';
            $el.html(paginationHTML);
        }
        if (params.type !== "custom") swiper.emit("paginationRender", swiper.pagination.$el[0]);
    },
    init: function init() {
        var swiper = this;
        swiper.params.pagination = (0, $8Ji4q.createElementIfNotDefined)(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
            el: "swiper-pagination"
        });
        var params = swiper.params.pagination;
        if (!params.el) return;
        var $el = (0, $1Lk6P.default)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) $el = swiper.$el.find(params.el);
        if (params.type === "bullets" && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        if (params.type === "bullets" && params.dynamicBullets) {
            $el.addClass("" + params.modifierClass + params.type + "-dynamic");
            swiper.pagination.dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === "progressbar" && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on("click", (0, $8Ji4q.classesToSelector)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            var index = (0, $1Lk6P.default)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        (0, $8Ji4q.extend)(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    },
    destroy: function destroy() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off("click", (0, $8Ji4q.classesToSelector)(params.bulletClass));
    }
};
var $70b49acd42116838$export$2e2bcd8739ae039 = {
    name: "pagination",
    params: {
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function formatFractionCurrent(number) {
                return number;
            },
            formatFractionTotal: function formatFractionTotal(number) {
                return number;
            },
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
            modifierClass: "swiper-pagination-",
            // NEW
            currentClass: "swiper-pagination-current",
            totalClass: "swiper-pagination-total",
            hiddenClass: "swiper-pagination-hidden",
            progressbarFillClass: "swiper-pagination-progressbar-fill",
            progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
            clickableClass: "swiper-pagination-clickable",
            // NEW
            lockClass: "swiper-pagination-lock"
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            pagination: $70b49acd42116838$var$_extends({
                dynamicBulletIndex: 0
            }, $70b49acd42116838$var$Pagination)
        });
    },
    on: {
        init: function init(swiper) {
            swiper.pagination.init();
            swiper.pagination.render();
            swiper.pagination.update();
        },
        activeIndexChange: function activeIndexChange(swiper) {
            if (swiper.params.loop) swiper.pagination.update();
            else if (typeof swiper.snapIndex === "undefined") swiper.pagination.update();
        },
        snapIndexChange: function snapIndexChange(swiper) {
            if (!swiper.params.loop) swiper.pagination.update();
        },
        slidesLengthChange: function slidesLengthChange(swiper) {
            if (swiper.params.loop) {
                swiper.pagination.render();
                swiper.pagination.update();
            }
        },
        snapGridLengthChange: function snapGridLengthChange(swiper) {
            if (!swiper.params.loop) {
                swiper.pagination.render();
                swiper.pagination.update();
            }
        },
        destroy: function destroy(swiper) {
            swiper.pagination.destroy();
        },
        "enable disable": function enableDisable(swiper) {
            var $el = swiper.pagination.$el;
            if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
        },
        click: function click(swiper, e) {
            var targetEl = e.target;
            if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0, $1Lk6P.default)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
                if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
                var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
                if (isHidden === true) swiper.emit("paginationShow");
                else swiper.emit("paginationHide");
                swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
            }
        }
    }
};

});

parcelRegister("hqsPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $cafb39a56d35dbb2$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $cafb39a56d35dbb2$var$_extends() {
    $cafb39a56d35dbb2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cafb39a56d35dbb2$var$_extends.apply(this, arguments);
}
var $cafb39a56d35dbb2$var$Scrollbar = {
    setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate, progress = swiper.progress;
        var dragSize = scrollbar.dragSize, trackSize = scrollbar.trackSize, $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        var params = swiper.params.scrollbar;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
            $dragEl[0].style.width = newSize + "px";
        } else {
            $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
            $dragEl[0].style.height = newSize + "px";
        }
        if (params.hide) {
            clearTimeout(swiper.scrollbar.timeout);
            $el[0].style.opacity = 1;
            swiper.scrollbar.timeout = setTimeout(function() {
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        var divider = swiper.size / swiper.virtualSize;
        var moveDivider = divider * (trackSize / swiper.size);
        var dragSize;
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = dragSize + "px";
        else $dragEl[0].style.height = dragSize + "px";
        if (divider >= 1) $el[0].style.display = "none";
        else $el[0].style.display = "";
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        (0, $8Ji4q.extend)(scrollbar, {
            trackSize: trackSize,
            divider: divider,
            moveDivider: moveDivider,
            dragSize: dragSize
        });
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
        var swiper = this;
        if (swiper.isHorizontal()) return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
        return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
    },
    setDragPosition: function setDragPosition(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var $el = scrollbar.$el, dragSize = scrollbar.dragSize, trackSize = scrollbar.trackSize, dragStartPos = scrollbar.dragStartPos;
        var positionRatio;
        positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
        swiper.scrollbar.isTouched = true;
        swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        scrollbar.setDragPosition(e);
        clearTimeout(swiper.scrollbar.dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css("opacity", 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css("scroll-snap-type", "none");
        swiper.emit("scrollbarDragStart", e);
    },
    onDragMove: function onDragMove(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
        if (!swiper.scrollbar.isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        scrollbar.setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        swiper.emit("scrollbarDragMove", e);
    },
    onDragEnd: function onDragEnd(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el;
        if (!swiper.scrollbar.isTouched) return;
        swiper.scrollbar.isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css("scroll-snap-type", "");
            $wrapperEl.transition("");
        }
        if (params.hide) {
            clearTimeout(swiper.scrollbar.dragTimeout);
            swiper.scrollbar.dragTimeout = (0, $8Ji4q.nextTick)(function() {
                $el.css("opacity", 0);
                $el.transition(400);
            }, 1000);
        }
        swiper.emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    },
    enableDraggable: function enableDraggable() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) return;
        var document = (0, $6fzuY.getDocument)();
        var scrollbar = swiper.scrollbar, touchEventsTouch = swiper.touchEventsTouch, touchEventsDesktop = swiper.touchEventsDesktop, params = swiper.params, support = swiper.support;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        if (!support.touch) {
            target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
            document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
            document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
            target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
            target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
            target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
    },
    disableDraggable: function disableDraggable() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) return;
        var document = (0, $6fzuY.getDocument)();
        var scrollbar = swiper.scrollbar, touchEventsTouch = swiper.touchEventsTouch, touchEventsDesktop = swiper.touchEventsDesktop, params = swiper.params, support = swiper.support;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        if (!support.touch) {
            target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
            document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
            document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
            target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
            target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
            target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
    },
    init: function init() {
        var swiper = this;
        var scrollbar = swiper.scrollbar, $swiperEl = swiper.$el;
        swiper.params.scrollbar = (0, $8Ji4q.createElementIfNotDefined)($swiperEl, swiper.params.scrollbar, swiper.params.createElements, {
            el: "swiper-scrollbar"
        });
        var params = swiper.params.scrollbar;
        if (!params.el) return;
        var $el = (0, $1Lk6P.default)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);
        if ($dragEl.length === 0) {
            $dragEl = (0, $1Lk6P.default)('<div class="' + swiper.params.scrollbar.dragClass + '"></div>');
            $el.append($dragEl);
        }
        (0, $8Ji4q.extend)(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) scrollbar.enableDraggable();
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    },
    destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.disableDraggable();
    }
};
var $cafb39a56d35dbb2$export$2e2bcd8739ae039 = {
    name: "scrollbar",
    params: {
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag"
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            scrollbar: $cafb39a56d35dbb2$var$_extends({
                isTouched: false,
                timeout: null,
                dragTimeout: null
            }, $cafb39a56d35dbb2$var$Scrollbar)
        });
    },
    on: {
        init: function init(swiper) {
            swiper.scrollbar.init();
            swiper.scrollbar.updateSize();
            swiper.scrollbar.setTranslate();
        },
        update: function update(swiper) {
            swiper.scrollbar.updateSize();
        },
        resize: function resize(swiper) {
            swiper.scrollbar.updateSize();
        },
        observerUpdate: function observerUpdate(swiper) {
            swiper.scrollbar.updateSize();
        },
        setTranslate: function setTranslate(swiper) {
            swiper.scrollbar.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            swiper.scrollbar.setTransition(duration);
        },
        "enable disable": function enableDisable(swiper) {
            var $el = swiper.scrollbar.$el;
            if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
        },
        destroy: function destroy(swiper) {
            swiper.scrollbar.destroy();
        }
    }
};

});

parcelRegister("7j3Wv", function(module, exports) {

$parcel$export(module.exports, "default", () => $551d5db2ccc8a37a$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $551d5db2ccc8a37a$var$_extends() {
    $551d5db2ccc8a37a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $551d5db2ccc8a37a$var$_extends.apply(this, arguments);
}
var $551d5db2ccc8a37a$var$Parallax = {
    setTransform: function setTransform(el, progress) {
        var swiper = this;
        var rtl = swiper.rtl;
        var $el = (0, $1Lk6P.default)(el);
        var rtlFactor = rtl ? -1 : 1;
        var p = $el.attr("data-swiper-parallax") || "0";
        var x = $el.attr("data-swiper-parallax-x");
        var y = $el.attr("data-swiper-parallax-y");
        var scale = $el.attr("data-swiper-parallax-scale");
        var opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = parseInt(x, 10) * progress * rtlFactor + "%";
        else x = x * progress * rtlFactor + "px";
        if (y.indexOf("%") >= 0) y = parseInt(y, 10) * progress + "%";
        else y = y * progress + "px";
        if (typeof opacity !== "undefined" && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) $el.transform("translate3d(" + x + ", " + y + ", 0px)");
        else {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")");
        }
    },
    setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid;
        $el.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(el) {
            swiper.parallax.setTransform(el, progress);
        });
        slides.each(function(slideEl, slideIndex) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $1Lk6P.default)(slideEl).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(el) {
                swiper.parallax.setTransform(el, slideProgress);
            });
        });
    },
    setTransition: function setTransition(duration) {
        if (duration === void 0) duration = this.params.speed;
        var swiper = this;
        var $el = swiper.$el;
        $el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(parallaxEl) {
            var $parallaxEl = (0, $1Lk6P.default)(parallaxEl);
            var parallaxDuration = parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    }
};
var $551d5db2ccc8a37a$export$2e2bcd8739ae039 = {
    name: "parallax",
    params: {
        parallax: {
            enabled: false
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            parallax: $551d5db2ccc8a37a$var$_extends({}, $551d5db2ccc8a37a$var$Parallax)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (!swiper.params.parallax.enabled) return;
            swiper.params.watchSlidesProgress = true;
            swiper.originalParams.watchSlidesProgress = true;
        },
        init: function init(swiper) {
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTranslate();
        },
        setTranslate: function setTranslate(swiper) {
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTransition(duration);
        }
    }
};

});

parcelRegister("hUEmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0a6faa19f432ae1$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $d0a6faa19f432ae1$var$_extends() {
    $d0a6faa19f432ae1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d0a6faa19f432ae1$var$_extends.apply(this, arguments);
}
var $d0a6faa19f432ae1$var$Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        var x1 = e.targetTouches[0].pageX;
        var y1 = e.targetTouches[0].pageY;
        var x2 = e.targetTouches[1].pageX;
        var y2 = e.targetTouches[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
        var swiper = this;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2) return;
            zoom.fakeGestureTouched = true;
            gesture.scaleStart = $d0a6faa19f432ae1$var$Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $1Lk6P.default)(e.target).closest("." + swiper.params.slideClass);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target");
            gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
            gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
        var swiper = this;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (!support.gestures) {
            if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2) return;
            zoom.fakeGestureMoved = true;
            gesture.scaleMove = $d0a6faa19f432ae1$var$Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === "gesturechange") zoom.onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * zoom.currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
    },
    onGestureEnd: function onGestureEnd(e) {
        var swiper = this;
        var device = swiper.device;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (!support.gestures) {
            if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) return;
            if (e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !device.android) return;
            zoom.fakeGestureTouched = false;
            zoom.fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
        zoom.currentScale = zoom.scale;
        zoom.isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    },
    onTouchStart: function onTouchStart(e) {
        var swiper = this;
        var device = swiper.device;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image, velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $8Ji4q.getTranslate)(gesture.$imageWrapEl[0], "x") || 0;
            image.startY = (0, $8Ji4q.getTranslate)(gesture.$imageWrapEl[0], "y") || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !zoom.isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
    },
    onTouchEnd: function onTouchEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image, velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
    },
    onTransitionEnd: function onTransitionEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform("translate3d(0,0,0)");
            zoom.scale = 1;
            zoom.currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoom.out();
        else // Zoom In
        zoom.in(e);
    },
    in: function _in(e) {
        var swiper = this;
        var window = (0, $6fzuY.getWindow)();
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture, image = zoom.image;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $1Lk6P.default)(e.target).closest("." + swiper.params.slideClass);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target");
            gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        gesture.$slideEl.addClass("" + params.zoomedSlideClass);
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        zoom.currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
    },
    out: function out() {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target");
            gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        zoom.scale = 1;
        zoom.currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
        gesture.$slideEl = undefined;
    },
    toggleGestures: function toggleGestures(method) {
        var swiper = this;
        var zoom = swiper.zoom;
        var selector = zoom.slideSelector, passive = zoom.passiveListener;
        swiper.$wrapperEl[method]("gesturestart", selector, zoom.onGestureStart, passive);
        swiper.$wrapperEl[method]("gesturechange", selector, zoom.onGestureChange, passive);
        swiper.$wrapperEl[method]("gestureend", selector, zoom.onGestureEnd, passive);
    },
    enableGestures: function enableGestures() {
        if (this.zoom.gesturesEnabled) return;
        this.zoom.gesturesEnabled = true;
        this.zoom.toggleGestures("on");
    },
    disableGestures: function disableGestures() {
        if (!this.zoom.gesturesEnabled) return;
        this.zoom.gesturesEnabled = false;
        this.zoom.toggleGestures("off");
    },
    // Attach/Detach Events
    enable: function enable() {
        var swiper = this;
        var support = swiper.support;
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var passiveListener = swiper.touchEvents.start === "touchstart" && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        var slideSelector = "." + swiper.params.slideClass;
        swiper.zoom.passiveListener = passiveListener;
        swiper.zoom.slideSelector = slideSelector; // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
    },
    disable: function disable() {
        var swiper = this;
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        var support = swiper.support;
        swiper.zoom.enabled = false;
        var passiveListener = swiper.touchEvents.start === "touchstart" && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        var slideSelector = "." + swiper.params.slideClass; // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
    }
};
var $d0a6faa19f432ae1$export$2e2bcd8739ae039 = {
    name: "zoom",
    params: {
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            zoom: $d0a6faa19f432ae1$var$_extends({
                enabled: false,
                scale: 1,
                currentScale: 1,
                isScaling: false,
                gesture: {
                    $slideEl: undefined,
                    slideWidth: undefined,
                    slideHeight: undefined,
                    $imageEl: undefined,
                    $imageWrapEl: undefined,
                    maxRatio: 3
                },
                image: {
                    isTouched: undefined,
                    isMoved: undefined,
                    currentX: undefined,
                    currentY: undefined,
                    minX: undefined,
                    minY: undefined,
                    maxX: undefined,
                    maxY: undefined,
                    width: undefined,
                    height: undefined,
                    startX: undefined,
                    startY: undefined,
                    touchesStart: {},
                    touchesCurrent: {}
                },
                velocity: {
                    x: undefined,
                    y: undefined,
                    prevPositionX: undefined,
                    prevPositionY: undefined,
                    prevTime: undefined
                }
            }, $d0a6faa19f432ae1$var$Zoom)
        });
        var scale = 1;
        Object.defineProperty(swiper.zoom, "scale", {
            get: function get() {
                return scale;
            },
            set: function set(value) {
                if (scale !== value) {
                    var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
                    var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
                    swiper.emit("zoomChange", value, imageEl, slideEl);
                }
                scale = value;
            }
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.zoom.enabled) swiper.zoom.enable();
        },
        destroy: function destroy(swiper) {
            swiper.zoom.disable();
        },
        touchStart: function touchStart(swiper, e) {
            if (!swiper.zoom.enabled) return;
            swiper.zoom.onTouchStart(e);
        },
        touchEnd: function touchEnd(swiper, e) {
            if (!swiper.zoom.enabled) return;
            swiper.zoom.onTouchEnd(e);
        },
        doubleTap: function doubleTap(swiper, e) {
            if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) swiper.zoom.toggle(e);
        },
        transitionEnd: function transitionEnd(swiper) {
            if (swiper.zoom.enabled && swiper.params.zoom.enabled) swiper.zoom.onTransitionEnd();
        },
        slideChange: function slideChange(swiper) {
            if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) swiper.zoom.onTransitionEnd();
        }
    }
};

});

parcelRegister("gpbet", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf17b1aec19611d5$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $bf17b1aec19611d5$var$_extends() {
    $bf17b1aec19611d5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bf17b1aec19611d5$var$_extends.apply(this, arguments);
}
var $bf17b1aec19611d5$var$Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
        if (loadInDuplicate === void 0) loadInDuplicate = true;
        var swiper = this;
        var params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var $slideEl = isVirtual ? swiper.$wrapperEl.children("." + swiper.params.slideClass + '[data-swiper-slide-index="' + index + '"]') : swiper.slides.eq(index);
        var $images = $slideEl.find("." + params.elementClass + ":not(." + params.loadedClass + "):not(." + params.loadingClass + ")");
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each(function(imageEl) {
            var $imageEl = (0, $1Lk6P.default)(imageEl);
            $imageEl.addClass(params.loadingClass);
            var background = $imageEl.attr("data-background");
            var src = $imageEl.attr("data-src");
            var srcset = $imageEl.attr("data-srcset");
            var sizes = $imageEl.attr("data-sizes");
            var $pictureEl = $imageEl.parent("picture");
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function() {
                if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css("background-image", 'url("' + background + '")');
                    $imageEl.removeAttr("data-background");
                } else {
                    if (srcset) {
                        $imageEl.attr("srcset", srcset);
                        $imageEl.removeAttr("data-srcset");
                    }
                    if (sizes) {
                        $imageEl.attr("sizes", sizes);
                        $imageEl.removeAttr("data-sizes");
                    }
                    if ($pictureEl.length) $pictureEl.children("source").each(function(sourceEl) {
                        var $source = (0, $1Lk6P.default)(sourceEl);
                        if ($source.attr("data-srcset")) {
                            $source.attr("srcset", $source.attr("data-srcset"));
                            $source.removeAttr("data-srcset");
                        }
                    });
                    if (src) {
                        $imageEl.attr("src", src);
                        $imageEl.removeAttr("data-src");
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find("." + params.preloaderClass).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    var slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        var originalSlide = swiper.$wrapperEl.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + swiper.params.slideDuplicateClass + ")");
                        swiper.lazy.loadInSlide(originalSlide.index(), false);
                    } else {
                        var duplicatedSlide = swiper.$wrapperEl.children("." + swiper.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
                        swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                swiper.emit("lazyImageReady", $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            swiper.emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
    },
    load: function load() {
        var swiper = this;
        var $wrapperEl = swiper.$wrapperEl, swiperParams = swiper.params, slides = swiper.slides, activeIndex = swiper.activeIndex;
        var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        var params = swiperParams.lazy;
        var slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children("." + swiperParams.slideClass + '[data-swiper-slide-index="' + index + '"]').length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $1Lk6P.default)(slideEl).attr("data-swiper-slide-index");
            return (0, $1Lk6P.default)(slideEl).index();
        }
        if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
        if (swiper.params.watchSlidesVisibility) $wrapperEl.children("." + swiperParams.slideVisibleClass).each(function(slideEl) {
            var index = isVirtual ? (0, $1Lk6P.default)(slideEl).attr("data-swiper-slide-index") : (0, $1Lk6P.default)(slideEl).index();
            swiper.lazy.loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(var i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) swiper.lazy.loadInSlide(i);
        } else swiper.lazy.loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                var amount = params.loadPrevNextAmount;
                var spv = slidesPerView;
                var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(var _i = activeIndex + slidesPerView; _i < maxIndex; _i += 1)if (slideExist(_i)) swiper.lazy.loadInSlide(_i);
                 // Prev Slides
                for(var _i2 = minIndex; _i2 < activeIndex; _i2 += 1)if (slideExist(_i2)) swiper.lazy.loadInSlide(_i2);
            } else {
                var nextSlide = $wrapperEl.children("." + swiperParams.slideNextClass);
                if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
                var prevSlide = $wrapperEl.children("." + swiperParams.slidePrevClass);
                if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
            }
        }
    },
    checkInViewOnLoad: function checkInViewOnLoad() {
        var window = (0, $6fzuY.getWindow)();
        var swiper = this;
        if (!swiper || swiper.destroyed) return;
        var $scrollElement = swiper.params.lazy.scrollingElement ? (0, $1Lk6P.default)(swiper.params.lazy.scrollingElement) : (0, $1Lk6P.default)(window);
        var isWindow = $scrollElement[0] === window;
        var scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        var scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        var swiperOffset = swiper.$el.offset();
        var rtl = swiper.rtlTranslate;
        var inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        var swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(var i = 0; i < swiperCoord.length; i += 1){
            var point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        var passiveListener = swiper.touchEvents.start === "touchstart" && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            swiper.lazy.load();
            $scrollElement.off("scroll", swiper.lazy.checkInViewOnLoad, passiveListener);
        } else if (!swiper.lazy.scrollHandlerAttached) {
            swiper.lazy.scrollHandlerAttached = true;
            $scrollElement.on("scroll", swiper.lazy.checkInViewOnLoad, passiveListener);
        }
    }
};
var $bf17b1aec19611d5$export$2e2bcd8739ae039 = {
    name: "lazy",
    params: {
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader"
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            lazy: $bf17b1aec19611d5$var$_extends({
                initialImageLoaded: false
            }, $bf17b1aec19611d5$var$Lazy)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
        },
        init: function init(swiper) {
            if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
                if (swiper.params.lazy.checkInView) swiper.lazy.checkInViewOnLoad();
                else swiper.lazy.load();
            }
        },
        scroll: function scroll(swiper) {
            if (swiper.params.freeMode && !swiper.params.freeModeSticky) swiper.lazy.load();
        },
        "scrollbarDragMove resize _freeModeNoMomentumRelease": function lazyLoad(swiper) {
            if (swiper.params.lazy.enabled) swiper.lazy.load();
        },
        transitionStart: function transitionStart(swiper) {
            if (swiper.params.lazy.enabled) {
                if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) swiper.lazy.load();
            }
        },
        transitionEnd: function transitionEnd(swiper) {
            if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) swiper.lazy.load();
        },
        slideChange: function slideChange(swiper) {
            var _swiper$params = swiper.params, lazy = _swiper$params.lazy, cssMode = _swiper$params.cssMode, watchSlidesVisibility = _swiper$params.watchSlidesVisibility, watchSlidesProgress = _swiper$params.watchSlidesProgress, touchReleaseOnEdges = _swiper$params.touchReleaseOnEdges, resistanceRatio = _swiper$params.resistanceRatio;
            if (lazy.enabled && (cssMode || (watchSlidesVisibility || watchSlidesProgress) && (touchReleaseOnEdges || resistanceRatio === 0))) swiper.lazy.load();
        }
    }
};

});

parcelRegister("3J7Lh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6b985d133f212c$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");
function $2b6b985d133f212c$var$_extends() {
    $2b6b985d133f212c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2b6b985d133f212c$var$_extends.apply(this, arguments);
}
var $2b6b985d133f212c$var$Controller = {
    LinearSpline: function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
        var swiper = this;
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new $2b6b985d133f212c$var$Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new $2b6b985d133f212c$var$Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    },
    setTranslate: function setTranslate(_setTranslate, byController) {
        var swiper = this;
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    },
    setTransition: function setTransition(duration, byController) {
        var swiper = this;
        var Swiper = swiper.constructor;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $8Ji4q.nextTick)(function() {
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(function() {
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === "slide") c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
};
var $2b6b985d133f212c$export$2e2bcd8739ae039 = {
    name: "controller",
    params: {
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            controller: $2b6b985d133f212c$var$_extends({
                control: swiper.params.controller.control
            }, $2b6b985d133f212c$var$Controller)
        });
    },
    on: {
        update: function update(swiper) {
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        resize: function resize(swiper) {
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        observerUpdate: function observerUpdate(swiper) {
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        setTranslate: function setTranslate(swiper, translate, byController) {
            if (!swiper.controller.control) return;
            swiper.controller.setTranslate(translate, byController);
        },
        setTransition: function setTransition(swiper, duration, byController) {
            if (!swiper.controller.control) return;
            swiper.controller.setTransition(duration, byController);
        }
    }
};

});

parcelRegister("lLvEQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0416d0b2dac29b6c$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $0416d0b2dac29b6c$var$_extends() {
    $0416d0b2dac29b6c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0416d0b2dac29b6c$var$_extends.apply(this, arguments);
}
var $0416d0b2dac29b6c$var$A11y = {
    getRandomNumber: function getRandomNumber(size) {
        if (size === void 0) size = 16;
        var randomChar = function randomChar() {
            return Math.round(16 * Math.random()).toString(16);
        };
        return "x".repeat(size).replace(/x/g, randomChar);
    },
    makeElFocusable: function makeElFocusable($el) {
        $el.attr("tabIndex", "0");
        return $el;
    },
    makeElNotFocusable: function makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
        return $el;
    },
    addElRole: function addElRole($el, role) {
        $el.attr("role", role);
        return $el;
    },
    addElRoleDescription: function addElRoleDescription($el, description) {
        $el.attr("aria-roledescription", description);
        return $el;
    },
    addElControls: function addElControls($el, controls) {
        $el.attr("aria-controls", controls);
        return $el;
    },
    addElLabel: function addElLabel($el, label) {
        $el.attr("aria-label", label);
        return $el;
    },
    addElId: function addElId($el, id) {
        $el.attr("id", id);
        return $el;
    },
    addElLive: function addElLive($el, live) {
        $el.attr("aria-live", live);
        return $el;
    },
    disableEl: function disableEl($el) {
        $el.attr("aria-disabled", true);
        return $el;
    },
    enableEl: function enableEl($el) {
        $el.attr("aria-disabled", false);
        return $el;
    },
    onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var swiper = this;
        var params = swiper.params.a11y;
        var $targetEl = (0, $1Lk6P.default)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) swiper.a11y.notify(params.lastSlideMessage);
            else swiper.a11y.notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) swiper.a11y.notify(params.firstSlideMessage);
            else swiper.a11y.notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $8Ji4q.classesToSelector)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    },
    notify: function notify(message) {
        var swiper = this;
        var notification = swiper.a11y.liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
    },
    updateNavigation: function updateNavigation() {
        var swiper = this;
        if (swiper.params.loop || !swiper.navigation) return;
        var _swiper$navigation = swiper.navigation, $nextEl = _swiper$navigation.$nextEl, $prevEl = _swiper$navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                swiper.a11y.disableEl($prevEl);
                swiper.a11y.makeElNotFocusable($prevEl);
            } else {
                swiper.a11y.enableEl($prevEl);
                swiper.a11y.makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                swiper.a11y.disableEl($nextEl);
                swiper.a11y.makeElNotFocusable($nextEl);
            } else {
                swiper.a11y.enableEl($nextEl);
                swiper.a11y.makeElFocusable($nextEl);
            }
        }
    },
    updatePagination: function updatePagination() {
        var swiper = this;
        var params = swiper.params.a11y;
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) swiper.pagination.bullets.each(function(bulletEl) {
            var $bulletEl = (0, $1Lk6P.default)(bulletEl);
            swiper.a11y.makeElFocusable($bulletEl);
            if (!swiper.params.pagination.renderBullet) {
                swiper.a11y.addElRole($bulletEl, "button");
                swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
            }
        });
    },
    init: function init() {
        var swiper = this;
        var params = swiper.params.a11y;
        swiper.$el.append(swiper.a11y.liveRegion); // Container
        var $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) swiper.a11y.addElLabel($containerEl, params.containerMessage);
         // Wrapper
        var $wrapperEl = swiper.$wrapperEl;
        var wrapperId = $wrapperEl.attr("id") || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
        var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        swiper.a11y.addElId($wrapperEl, wrapperId);
        swiper.a11y.addElLive($wrapperEl, live); // Slide
        if (params.itemRoleDescriptionMessage) swiper.a11y.addElRoleDescription((0, $1Lk6P.default)(swiper.slides), params.itemRoleDescriptionMessage);
        swiper.a11y.addElRole((0, $1Lk6P.default)(swiper.slides), params.slideRole);
        var slidesLength = swiper.params.loop ? swiper.slides.filter(function(el) {
            return !el.classList.contains(swiper.params.slideDuplicateClass);
        }).length : swiper.slides.length;
        swiper.slides.each(function(slideEl, index) {
            var $slideEl = (0, $1Lk6P.default)(slideEl);
            var slideIndex = swiper.params.loop ? parseInt($slideEl.attr("data-swiper-slide-index"), 10) : index;
            var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            swiper.a11y.addElLabel($slideEl, ariaLabelMessage);
        }); // Navigation
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) {
            swiper.a11y.makeElFocusable($nextEl);
            if ($nextEl[0].tagName !== "BUTTON") {
                swiper.a11y.addElRole($nextEl, "button");
                $nextEl.on("keydown", swiper.a11y.onEnterOrSpaceKey);
            }
            swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
            swiper.a11y.addElControls($nextEl, wrapperId);
        }
        if ($prevEl && $prevEl.length) {
            swiper.a11y.makeElFocusable($prevEl);
            if ($prevEl[0].tagName !== "BUTTON") {
                swiper.a11y.addElRole($prevEl, "button");
                $prevEl.on("keydown", swiper.a11y.onEnterOrSpaceKey);
            }
            swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
            swiper.a11y.addElControls($prevEl, wrapperId);
        } // Pagination
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) swiper.pagination.$el.on("keydown", (0, $8Ji4q.classesToSelector)(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    },
    destroy: function destroy() {
        var swiper = this;
        if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off("keydown", swiper.a11y.onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off("keydown", swiper.a11y.onEnterOrSpaceKey);
         // Pagination
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) swiper.pagination.$el.off("keydown", (0, $8Ji4q.classesToSelector)(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    }
};
var $0416d0b2dac29b6c$export$2e2bcd8739ae039 = {
    name: "a11y",
    params: {
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group"
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            a11y: $0416d0b2dac29b6c$var$_extends({}, $0416d0b2dac29b6c$var$A11y, {
                liveRegion: (0, $1Lk6P.default)('<span class="' + swiper.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
            })
        });
    },
    on: {
        afterInit: function afterInit(swiper) {
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.init();
            swiper.a11y.updateNavigation();
        },
        toEdge: function toEdge(swiper) {
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updateNavigation();
        },
        fromEdge: function fromEdge(swiper) {
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updateNavigation();
        },
        paginationUpdate: function paginationUpdate(swiper) {
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updatePagination();
        },
        destroy: function destroy(swiper) {
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.destroy();
        }
    }
};

});

parcelRegister("iGlyi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d99cde0da4c82ddf$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $8Ji4q = parcelRequire("8Ji4q");
function $d99cde0da4c82ddf$var$_extends() {
    $d99cde0da4c82ddf$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d99cde0da4c82ddf$var$_extends.apply(this, arguments);
}
var $d99cde0da4c82ddf$var$History = {
    init: function init() {
        var swiper = this;
        var window = (0, $6fzuY.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        var history = swiper.history;
        history.initialized = true;
        history.paths = $d99cde0da4c82ddf$var$History.getPathValues(swiper.params.url);
        if (!history.paths.key && !history.paths.value) return;
        history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", swiper.history.setHistoryPopState);
    },
    destroy: function destroy() {
        var swiper = this;
        var window = (0, $6fzuY.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", swiper.history.setHistoryPopState);
    },
    setHistoryPopState: function setHistoryPopState() {
        var swiper = this;
        swiper.history.paths = $d99cde0da4c82ddf$var$History.getPathValues(swiper.params.url);
        swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues(urlOverride) {
        var window = (0, $6fzuY.getWindow)();
        var location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        var pathArray = location.pathname.slice(1).split("/").filter(function(part) {
            return part !== "";
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    },
    setHistory: function setHistory(key, index) {
        var swiper = this;
        var window = (0, $6fzuY.getWindow)();
        if (!swiper.history.initialized || !swiper.params.history.enabled) return;
        var location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        var slide = swiper.slides.eq(index);
        var value = $d99cde0da4c82ddf$var$History.slugify(slide.attr("data-history"));
        if (swiper.params.history.root.length > 0) {
            var root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = root + "/" + key + "/" + value;
        } else if (!location.pathname.includes(key)) value = key + "/" + value;
        var currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    },
    slugify: function slugify(text) {
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
        var swiper = this;
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides.eq(i);
            var slideHistory = $d99cde0da4c82ddf$var$History.slugify(slide.attr("data-history"));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                var index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    }
};
var $d99cde0da4c82ddf$export$2e2bcd8739ae039 = {
    name: "history",
    params: {
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides"
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            history: $d99cde0da4c82ddf$var$_extends({}, $d99cde0da4c82ddf$var$History)
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.history.enabled) swiper.history.init();
        },
        destroy: function destroy(swiper) {
            if (swiper.params.history.enabled) swiper.history.destroy();
        },
        "transitionEnd _freeModeNoMomentumRelease": function transitionEnd_freeModeNoMomentumRelease(swiper) {
            if (swiper.history.initialized) swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        },
        slideChange: function slideChange(swiper) {
            if (swiper.history.initialized && swiper.params.cssMode) swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
    }
};

});

parcelRegister("k7pzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea584c85c121b28c$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $ea584c85c121b28c$var$_extends() {
    $ea584c85c121b28c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ea584c85c121b28c$var$_extends.apply(this, arguments);
}
var $ea584c85c121b28c$var$HashNavigation = {
    onHashChange: function onHashChange() {
        var swiper = this;
        var document = (0, $6fzuY.getDocument)();
        swiper.emit("hashChange");
        var newHash = document.location.hash.replace("#", "");
        var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr("data-hash");
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.$wrapperEl.children("." + swiper.params.slideClass + '[data-hash="' + newHash + '"]').index();
            if (typeof newIndex === "undefined") return;
            swiper.slideTo(newIndex);
        }
    },
    setHash: function setHash() {
        var swiper = this;
        var window = (0, $6fzuY.getWindow)();
        var document = (0, $6fzuY.getDocument)();
        if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, "#" + swiper.slides.eq(swiper.activeIndex).attr("data-hash"));
            swiper.emit("hashSet");
        } else {
            var slide = swiper.slides.eq(swiper.activeIndex);
            var hash = slide.attr("data-hash") || slide.attr("data-history");
            document.location.hash = hash || "";
            swiper.emit("hashSet");
        }
    },
    init: function init() {
        var swiper = this;
        var document = (0, $6fzuY.getDocument)();
        var window = (0, $6fzuY.getWindow)();
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        swiper.hashNavigation.initialized = true;
        var hash = document.location.hash.replace("#", "");
        if (hash) {
            var speed = 0;
            for(var i = 0, length = swiper.slides.length; i < length; i += 1){
                var slide = swiper.slides.eq(i);
                var slideHash = slide.attr("data-hash") || slide.attr("data-history");
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    var index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $1Lk6P.default)(window).on("hashchange", swiper.hashNavigation.onHashChange);
    },
    destroy: function destroy() {
        var swiper = this;
        var window = (0, $6fzuY.getWindow)();
        if (swiper.params.hashNavigation.watchState) (0, $1Lk6P.default)(window).off("hashchange", swiper.hashNavigation.onHashChange);
    }
};
var $ea584c85c121b28c$export$2e2bcd8739ae039 = {
    name: "hash-navigation",
    params: {
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            hashNavigation: $ea584c85c121b28c$var$_extends({
                initialized: false
            }, $ea584c85c121b28c$var$HashNavigation)
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.hashNavigation.enabled) swiper.hashNavigation.init();
        },
        destroy: function destroy(swiper) {
            if (swiper.params.hashNavigation.enabled) swiper.hashNavigation.destroy();
        },
        "transitionEnd _freeModeNoMomentumRelease": function transitionEnd_freeModeNoMomentumRelease(swiper) {
            if (swiper.hashNavigation.initialized) swiper.hashNavigation.setHash();
        },
        slideChange: function slideChange(swiper) {
            if (swiper.hashNavigation.initialized && swiper.params.cssMode) swiper.hashNavigation.setHash();
        }
    }
};

});

parcelRegister("lXyaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffc99e0a8d04687b$export$2e2bcd8739ae039);

var $6fzuY = parcelRequire("6fzuY");

var $8Ji4q = parcelRequire("8Ji4q");
function $ffc99e0a8d04687b$var$_extends() {
    $ffc99e0a8d04687b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ffc99e0a8d04687b$var$_extends.apply(this, arguments);
}
var $ffc99e0a8d04687b$var$Autoplay = {
    run: function run() {
        var swiper = this;
        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        var delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = (0, $8Ji4q.nextTick)(function() {
            var autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    swiper.emit("autoplay");
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    swiper.emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    swiper.emit("autoplay");
                } else swiper.autoplay.stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                swiper.emit("autoplay");
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                swiper.emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                swiper.emit("autoplay");
            } else swiper.autoplay.stop();
            if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();
            else if (autoplayResult === false) swiper.autoplay.run();
        }, delay);
    },
    start: function start() {
        var swiper = this;
        if (typeof swiper.autoplay.timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        swiper.emit("autoplayStart");
        swiper.autoplay.run();
        return true;
    },
    stop: function stop() {
        var swiper = this;
        if (!swiper.autoplay.running) return false;
        if (typeof swiper.autoplay.timeout === "undefined") return false;
        if (swiper.autoplay.timeout) {
            clearTimeout(swiper.autoplay.timeout);
            swiper.autoplay.timeout = undefined;
        }
        swiper.autoplay.running = false;
        swiper.emit("autoplayStop");
        return true;
    },
    pause: function pause(speed) {
        var swiper = this;
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            swiper.autoplay.run();
        } else [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach(function(event) {
            swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
        });
    },
    onVisibilityChange: function onVisibilityChange() {
        var swiper = this;
        var document = (0, $6fzuY.getDocument)();
        if (document.visibilityState === "hidden" && swiper.autoplay.running) swiper.autoplay.pause();
        if (document.visibilityState === "visible" && swiper.autoplay.paused) {
            swiper.autoplay.run();
            swiper.autoplay.paused = false;
        }
    },
    onTransitionEnd: function onTransitionEnd(e) {
        var swiper = this;
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach(function(event) {
            swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) swiper.autoplay.stop();
        else swiper.autoplay.run();
    },
    onMouseEnter: function onMouseEnter() {
        var swiper = this;
        if (swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
        else swiper.autoplay.pause();
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach(function(event) {
            swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
        });
    },
    onMouseLeave: function onMouseLeave() {
        var swiper = this;
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
    },
    attachMouseEvents: function attachMouseEvents() {
        var swiper = this;
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on("mouseenter", swiper.autoplay.onMouseEnter);
            swiper.$el.on("mouseleave", swiper.autoplay.onMouseLeave);
        }
    },
    detachMouseEvents: function detachMouseEvents() {
        var swiper = this;
        swiper.$el.off("mouseenter", swiper.autoplay.onMouseEnter);
        swiper.$el.off("mouseleave", swiper.autoplay.onMouseLeave);
    }
};
var $ffc99e0a8d04687b$export$2e2bcd8739ae039 = {
    name: "autoplay",
    params: {
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            autoplay: $ffc99e0a8d04687b$var$_extends({}, $ffc99e0a8d04687b$var$Autoplay, {
                running: false,
                paused: false
            })
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.autoplay.enabled) {
                swiper.autoplay.start();
                var document = (0, $6fzuY.getDocument)();
                document.addEventListener("visibilitychange", swiper.autoplay.onVisibilityChange);
                swiper.autoplay.attachMouseEvents();
            }
        },
        beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
            if (swiper.autoplay.running) {
                if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
                else swiper.autoplay.stop();
            }
        },
        sliderFirstMove: function sliderFirstMove(swiper) {
            if (swiper.autoplay.running) {
                if (swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                else swiper.autoplay.pause();
            }
        },
        touchEnd: function touchEnd(swiper) {
            if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.run();
        },
        destroy: function destroy(swiper) {
            swiper.autoplay.detachMouseEvents();
            if (swiper.autoplay.running) swiper.autoplay.stop();
            var document = (0, $6fzuY.getDocument)();
            document.removeEventListener("visibilitychange", swiper.autoplay.onVisibilityChange);
        }
    }
};

});

parcelRegister("8uDNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $62effe4394ba228b$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");
function $62effe4394ba228b$var$_extends() {
    $62effe4394ba228b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $62effe4394ba228b$var$_extends.apply(this, arguments);
}
var $62effe4394ba228b$var$Fade = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = swiper.slides.eq(i);
            var offset = $slideEl[0].swiperSlideOffset;
            var tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            $slideEl.css({
                opacity: slideOpacity
            }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides, $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
            var eventTriggered = false;
            slides.transitionEnd(function() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                var triggerEvents = [
                    "webkitTransitionEnd",
                    "transitionend"
                ];
                for(var i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
            });
        }
    }
};
var $62effe4394ba228b$export$2e2bcd8739ae039 = {
    name: "effect-fade",
    params: {
        fadeEffect: {
            crossFade: false
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            fadeEffect: $62effe4394ba228b$var$_extends({}, $62effe4394ba228b$var$Fade)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (swiper.params.effect !== "fade") return;
            swiper.classNames.push(swiper.params.containerModifierClass + "fade");
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: true
            };
            (0, $8Ji4q.extend)(swiper.params, overwriteParams);
            (0, $8Ji4q.extend)(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate(swiper) {
            if (swiper.params.effect !== "fade") return;
            swiper.fadeEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            if (swiper.params.effect !== "fade") return;
            swiper.fadeEffect.setTransition(duration);
        }
    }
};

});

parcelRegister("l6k8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5c9c7d55e428ac6$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $f5c9c7d55e428ac6$var$_extends() {
    $f5c9c7d55e428ac6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f5c9c7d55e428ac6$var$_extends.apply(this, arguments);
}
var $f5c9c7d55e428ac6$var$Cube = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size, browser = swiper.browser;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $1Lk6P.default)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: swiperWidth + "px"
                });
            } else {
                $cubeShadowEl = $el.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $1Lk6P.default)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) {
                // Set shadows
                var shadowBefore = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var shadowAfter = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if (shadowBefore.length === 0) {
                    shadowBefore = (0, $1Lk6P.default)('<div class="swiper-slide-shadow-' + (isHorizontal ? "left" : "top") + '"></div>');
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = (0, $1Lk6P.default)('<div class="swiper-slide-shadow-' + (isHorizontal ? "right" : "bottom") + '"></div>');
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
        }
        $wrapperEl.css({
            "-webkit-transform-origin": "50% 50% -" + swiperSize / 2 + "px",
            "-moz-transform-origin": "50% 50% -" + swiperSize / 2 + "px",
            "-ms-transform-origin": "50% 50% -" + swiperSize / 2 + "px",
            "transform-origin": "50% 50% -" + swiperSize / 2 + "px"
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform("translate3d(0px, " + (swiperWidth / 2 + params.shadowOffset) + "px, " + -swiperWidth / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + params.shadowScale + ")");
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var offset = params.shadowOffset;
                $cubeShadowEl.transform("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + (swiperHeight / 2 + offset) + "px, " + -swiperHeight / 2 / scale2 + "px) rotateX(-90deg)");
            }
        }
        var zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)");
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        var $el = swiper.$el, slides = swiper.slides;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find(".swiper-cube-shadow").transition(duration);
    }
};
var $f5c9c7d55e428ac6$export$2e2bcd8739ae039 = {
    name: "effect-cube",
    params: {
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            cubeEffect: $f5c9c7d55e428ac6$var$_extends({}, $f5c9c7d55e428ac6$var$Cube)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (swiper.params.effect !== "cube") return;
            swiper.classNames.push(swiper.params.containerModifierClass + "cube");
            swiper.classNames.push(swiper.params.containerModifierClass + "3d");
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
            (0, $8Ji4q.extend)(swiper.params, overwriteParams);
            (0, $8Ji4q.extend)(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate(swiper) {
            if (swiper.params.effect !== "cube") return;
            swiper.cubeEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            if (swiper.params.effect !== "cube") return;
            swiper.cubeEffect.setTransition(duration);
        }
    }
};

});

parcelRegister("9lTns", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf107fc746de2db$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $6cf107fc746de2db$var$_extends() {
    $6cf107fc746de2db$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6cf107fc746de2db$var$_extends.apply(this, arguments);
}
var $6cf107fc746de2db$var$Flip = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var offset = $slideEl[0].swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = -offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (swiper.params.flipEffect.slideShadows) {
                // Set shadows
                var shadowBefore = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var shadowAfter = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if (shadowBefore.length === 0) {
                    shadowBefore = (0, $1Lk6P.default)('<div class="swiper-slide-shadow-' + (swiper.isHorizontal() ? "left" : "top") + '"></div>');
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = (0, $1Lk6P.default)('<div class="swiper-slide-shadow-' + (swiper.isHorizontal() ? "right" : "bottom") + '"></div>');
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
            $slideEl.transform("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)");
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides, activeIndex = swiper.activeIndex, $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
            var eventTriggered = false; // eslint-disable-next-line
            slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return; // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
                eventTriggered = true;
                swiper.animating = false;
                var triggerEvents = [
                    "webkitTransitionEnd",
                    "transitionend"
                ];
                for(var i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
            });
        }
    }
};
var $6cf107fc746de2db$export$2e2bcd8739ae039 = {
    name: "effect-flip",
    params: {
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            flipEffect: $6cf107fc746de2db$var$_extends({}, $6cf107fc746de2db$var$Flip)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (swiper.params.effect !== "flip") return;
            swiper.classNames.push(swiper.params.containerModifierClass + "flip");
            swiper.classNames.push(swiper.params.containerModifierClass + "3d");
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: true
            };
            (0, $8Ji4q.extend)(swiper.params, overwriteParams);
            (0, $8Ji4q.extend)(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate(swiper) {
            if (swiper.params.effect !== "flip") return;
            swiper.flipEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            if (swiper.params.effect !== "flip") return;
            swiper.flipEffect.setTransition(duration);
        }
    }
};

});

parcelRegister("cnVyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $90444807fea38c36$export$2e2bcd8739ae039);

var $1Lk6P = parcelRequire("1Lk6P");

var $8Ji4q = parcelRequire("8Ji4q");
function $90444807fea38c36$var$_extends() {
    $90444807fea38c36$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $90444807fea38c36$var$_extends.apply(this, arguments);
}
var $90444807fea38c36$var$Coverflow = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth; // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var $slideEl = slides.eq(i);
            var slideSize = slidesSizesGrid[i];
            var slideOffset = $slideEl[0].swiperSlideOffset;
            var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg) scale(" + scale + ")";
            $slideEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var $shadowBeforeEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var $shadowAfterEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if ($shadowBeforeEl.length === 0) {
                    $shadowBeforeEl = (0, $1Lk6P.default)('<div class="swiper-slide-shadow-' + (isHorizontal ? "left" : "top") + '"></div>');
                    $slideEl.append($shadowBeforeEl);
                }
                if ($shadowAfterEl.length === 0) {
                    $shadowAfterEl = (0, $1Lk6P.default)('<div class="swiper-slide-shadow-' + (isHorizontal ? "right" : "bottom") + '"></div>');
                    $slideEl.append($shadowAfterEl);
                }
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
    }
};
var $90444807fea38c36$export$2e2bcd8739ae039 = {
    name: "effect-coverflow",
    params: {
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            coverflowEffect: $90444807fea38c36$var$_extends({}, $90444807fea38c36$var$Coverflow)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            if (swiper.params.effect !== "coverflow") return;
            swiper.classNames.push(swiper.params.containerModifierClass + "coverflow");
            swiper.classNames.push(swiper.params.containerModifierClass + "3d");
            swiper.params.watchSlidesProgress = true;
            swiper.originalParams.watchSlidesProgress = true;
        },
        setTranslate: function setTranslate(swiper) {
            if (swiper.params.effect !== "coverflow") return;
            swiper.coverflowEffect.setTranslate();
        },
        setTransition: function setTransition(swiper, duration) {
            if (swiper.params.effect !== "coverflow") return;
            swiper.coverflowEffect.setTransition(duration);
        }
    }
};

});

parcelRegister("7jHm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $553bf064ef2afa18$export$2e2bcd8739ae039);

var $8Ji4q = parcelRequire("8Ji4q");

var $1Lk6P = parcelRequire("1Lk6P");
function $553bf064ef2afa18$var$_extends() {
    $553bf064ef2afa18$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $553bf064ef2afa18$var$_extends.apply(this, arguments);
}
var $553bf064ef2afa18$var$Thumbs = {
    init: function init() {
        var swiper = this;
        var thumbsParams = swiper.params.thumbs;
        if (swiper.thumbs.initialized) return false;
        swiper.thumbs.initialized = true;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            (0, $8Ji4q.extend)(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            (0, $8Ji4q.extend)(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $8Ji4q.isObject)(thumbsParams.swiper)) {
            swiper.thumbs.swiper = new SwiperClass((0, $8Ji4q.extend)({}, thumbsParams.swiper, {
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                slideToClickedSlide: false
            }));
            swiper.thumbs.swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", swiper.thumbs.onThumbClick);
        return true;
    },
    onThumbClick: function onThumbClick() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $1Lk6P.default)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $1Lk6P.default)(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            var currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            var prevIndex = swiper.slides.eq(currentIndex).prevAll('[data-swiper-slide-index="' + slideToIndex + '"]').eq(0).index();
            var nextIndex = swiper.slides.eq(currentIndex).nextAll('[data-swiper-slide-index="' + slideToIndex + '"]').eq(0).index();
            if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
            else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll('[data-swiper-slide-index="' + swiper.realIndex + '"]').eq(0).index();
                var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll('[data-swiper-slide-index="' + swiper.realIndex + '"]').eq(0).index();
                if (typeof prevThumbsIndex === "undefined") newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === "undefined") newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        } // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(var i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children('[data-swiper-slide-index="' + (swiper.realIndex + i) + '"]').addClass(thumbActiveClass);
        else for(var _i = 0; _i < thumbsToActivate; _i += 1)thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
    }
};
var $553bf064ef2afa18$export$2e2bcd8739ae039 = {
    name: "thumbs",
    params: {
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-container-thumbs"
        }
    },
    create: function create() {
        var swiper = this;
        (0, $8Ji4q.bindModuleMethods)(swiper, {
            thumbs: $553bf064ef2afa18$var$_extends({
                swiper: null,
                initialized: false
            }, $553bf064ef2afa18$var$Thumbs)
        });
    },
    on: {
        beforeInit: function beforeInit(swiper) {
            var thumbs = swiper.params.thumbs;
            if (!thumbs || !thumbs.swiper) return;
            swiper.thumbs.init();
            swiper.thumbs.update(true);
        },
        slideChange: function slideChange(swiper) {
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        update: function update(swiper) {
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        resize: function resize(swiper) {
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        observerUpdate: function observerUpdate(swiper) {
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        setTransition: function setTransition(swiper, duration) {
            var thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper) return;
            thumbsSwiper.setTransition(duration);
        },
        beforeDestroy: function beforeDestroy(swiper) {
            var thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper) return;
            if (swiper.thumbs.swiperCreated && thumbsSwiper) thumbsSwiper.destroy();
        }
    }
};

});


parcelRegister("6Ny6s", function(module, exports) {

$parcel$export(module.exports, "formatMoney", () => $4f31c5d55b61de56$export$a17b3c2052469c69);
$parcel$export(module.exports, "fetchCartData", () => $4f31c5d55b61de56$export$6a814fef09afa7ac);
$parcel$export(module.exports, "hideCartModal", () => $4f31c5d55b61de56$export$569d845562b165b0);
$parcel$export(module.exports, "showAddToCartPreview", () => $4f31c5d55b61de56$export$b2ae74634740021f);
$parcel$export(module.exports, "showCartHoverPreview", () => $4f31c5d55b61de56$export$c2b9dca3fec345a8);
$parcel$export(module.exports, "formatBreedName", () => $4f31c5d55b61de56$export$7d51c8457efa5789);
// --------------------------------
// Format a number of cents into USD currency format
// --------------------------------
function $4f31c5d55b61de56$export$a17b3c2052469c69(cents) {
    return `$${(cents / 100).toFixed(2)}`;
}
function $4f31c5d55b61de56$export$7a2e37b19de8e5a6(item) {
    return `
    <div class="cart-preview-item">
      ${item.image ? `<img src="${item.image}" alt="${item.title}" class="cart-item-image">` : ""}
      <div class="cart-item-details">
        <h4>${item.title}</h4>
        <p>Qty: ${item.quantity}</p>
        <p class="price">${$4f31c5d55b61de56$export$a17b3c2052469c69(item.line_price)}</p>
      </div>
    </div>
  `;
}
function $4f31c5d55b61de56$export$6247a3368ba0dc10(items, totalPrice, addToCart = false, cartItemKey = null) {
    const MAX_VISIBLE_ITEMS = 3;
    const hasMultipleItems = items.length > 1;
    const isScrollable = items.length > MAX_VISIBLE_ITEMS;
    let displayedItems = items;
    // Check if it is an add-to-cart preview
    // If so, filter out the item being added if it exists
    if (addToCart && cartItemKey) displayedItems = items.filter((item)=>item.key !== cartItemKey);
    const cartItemsHTML = displayedItems.map($4f31c5d55b61de56$export$7a2e37b19de8e5a6).join("");
    // Show total price only if there are multiple items and is add-to-cart preview or if addToCart is false
    const shouldShowTotal = !addToCart || addToCart && hasMultipleItems;
    return `
    <div class="cart-preview">
      <div class="cart-items-wrapper${isScrollable ? " scrollable" : ""}">
        ${cartItemsHTML}
      </div>
      ${shouldShowTotal ? `
        <div class="cart-total">
          <p id="cart-total">Total: ${$4f31c5d55b61de56$export$a17b3c2052469c69(totalPrice)}</p>
        </div>
      ` : ""}
    </div>
  `;
}
async function $4f31c5d55b61de56$export$6a814fef09afa7ac() {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart data");
    return await response.json();
}
function $4f31c5d55b61de56$export$8de661b730965f3e(html) {
    const cartMessage = document.getElementById("cart-message");
    const cartItem = document.getElementById("cart-item");
    if (!cartMessage || !cartItem) {
        console.error("Cart modal elements missing");
        return;
    }
    cartItem.innerHTML = html;
    cartMessage.style.display = "block";
    cartMessage.classList.add("active");
}
function $4f31c5d55b61de56$export$569d845562b165b0() {
    const cartMessage = document.getElementById("cart-message");
    if (cartMessage) {
        cartMessage.classList.remove("active");
        setTimeout(()=>{
            cartMessage.style.display = "none";
        }, 300);
    }
}
// --------------------------------
// Generic function to fetch cart data and display a preview modal
// Behavior is controlled by options passed in
// --------------------------------
async function $4f31c5d55b61de56$var$showCartPreview({ addToCart: addToCart = false, useAddToCartWrapper: useAddToCartWrapper = false, cartItemKey: cartItemKey = null }) {
    try {
        const cartData = await $4f31c5d55b61de56$export$6a814fef09afa7ac();
        if (!cartData.items?.length) {
            $4f31c5d55b61de56$export$569d845562b165b0();
            return;
        }
        const html = $4f31c5d55b61de56$export$6247a3368ba0dc10(cartData.items, cartData.total_price, addToCart, cartItemKey);
        const wrapper = document.getElementById("cart-preview-wrapper");
        if (useAddToCartWrapper) // Show in the dedicated add-to-cart preview wrapper
        {
            if (wrapper) {
                wrapper.innerHTML = html;
                wrapper.style.display = "block";
            }
        } else {
            // Show in the main cart modal
            $4f31c5d55b61de56$export$8de661b730965f3e(html);
            // Hide add-to-cart preview wrapper if it was open
            if (wrapper) {
                wrapper.innerHTML = "";
                wrapper.style.display = "none";
            }
        }
    } catch (error) {
        console.error(addToCart ? "Add-to-cart error:" : "Cart hover error:", error);
    }
}
function $4f31c5d55b61de56$export$b2ae74634740021f(cartItemKey) {
    return $4f31c5d55b61de56$var$showCartPreview({
        addToCart: true,
        useAddToCartWrapper: true,
        cartItemKey: cartItemKey
    });
}
function $4f31c5d55b61de56$export$c2b9dca3fec345a8() {
    return $4f31c5d55b61de56$var$showCartPreview({
        addToCart: false,
        useAddToCartWrapper: false
    });
}
function $4f31c5d55b61de56$export$7d51c8457efa5789(breedTag) {
    return breedTag.replace(/([a-z])([A-Z])/g, "$1 $2");
}

});

parcelRegister("hRgcM", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("lvdU8")).then(()=>parcelRequire("1NSUj"));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case "preload":
            return $55a6d16921f8ab25$var$cachedPreloads;
        case "prefetch":
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("47e0r", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("8TD9g"))((parcelRequire("kI8SP")).resolve("jE8iD")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("alGBp")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("lQIoO"))
]).then(()=>parcelRequire("1HKgx"));

});
parcelRegister("8TD9g", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});


var $7e79c8bf8e5b9575$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL("f5dQu"), JSON.parse('["f5dQu","main.parcel.js","lvdU8","router.parcel.f2f83807.js","dlBC6","page-index.parcel.b60ac302.js","lQIoO","render-quickshop.parcel.ce4a4ff6.js","alGBp","page-account.7c82cb71.js","jE8iD","render-quickshop.1ec5a7a9.css","3piaI","page-collection.parcel.7eea1e3f.js","2pFUr","page-product.parcel.74db6606.js","5vEui","page-product.d642ebb1.css","bo14t","page-cart.parcel.77d1c94b.js","3kfSV","page-account.parcel.5fae2058.js","kM1nC","page-addresses.parcel.01fa5557.js"]'));

/*-------------------------------------------- */ /** Globals */ /*-------------------------------------------- */ const $c261a752fa03fc9c$export$7cb6f4d3b4eaa9bb = ()=>{
    const modal = document.createElement("div");
    modal.id = "blue-interstitial";
    modal.innerHTML = `
    <div class="blue-box">
      <div class="spinner"></div>
      <div class="text">Loading...</div>
    </div>
  `;
    const style = document.createElement("style");
    style.textContent = `
    #blue-interstitial {
      position: fixed;
      inset: 0;
      background: rgba(0, 60, 150, 0.95);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      transition: opacity .3s ease;
    }
    #blue-interstitial.fade {
      opacity: 0;
      pointer-events: none;
    }
    .blue-box {
      text-align: center;
      color: #fff;
      font-family: system-ui, sans-serif;
    }
    .spinner {
      width: 40px;
      height: 40px;
      margin: 0 auto 15px;
      border: 4px solid rgba(255,255,255,.3);
      border-top-color: #fff;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
    @keyframes spin { to { transform: rotate(360deg); } }
  `;
    document.head.appendChild(style);
    document.body.appendChild(modal);
};
const $c261a752fa03fc9c$export$504da2283d222aed = ()=>{
    const modal = document.querySelector("#blue-interstitial");
    modal.classList.add("fade");
    setTimeout(()=>modal.remove(), 300);
};
document.addEventListener("click", (e)=>{
    const action = e.target.closest("[data-action]")?.dataset.action;
    if (action === "akc-login") window.akc?.getLoginScreenset();
    if (action === "akc-logout") window.akc?.getLogoutScreenset();
});


const $2d69ca035e69e29f$var$doMultipass = (res)=>{
    let data = {
        id: res.UID,
        email: res.profile.email,
        firstName: res.profile.firstName,
        lastName: res.profile.lastName,
        returnMultipassToken: true
    };
    const url = window.location.href;
    const urlObj = new URL(url);
    const returnUrl = urlObj.searchParams.get("return_url");
    if (returnUrl && urlObj.hash) window.loginReturnTo = returnUrl + urlObj.hash;
    if (window.loginReturnTo) data.returnTo = window.loginReturnTo;
    fetch(window.akc.services.multipassUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then((res)=>res.json()).then((data)=>{
        window.localStorage.setItem("multipassToken", data.token);
        window.localStorage.removeItem("customerAccessToken");
        window.localStorage.removeItem("customerAccessTokenExpiresAt");
        window.location.href = data.authUrl;
    }).catch((err)=>console.error(err));
};
const $2d69ca035e69e29f$var$initRecaptcha = (action, callback = null)=>{
    return new Promise((resolve, reject)=>{
        window.grecaptcha.ready(()=>{
            window.grecaptcha.execute(window.akc.recaptcha.siteKey, {
                action: action
            }).then((token)=>{
                if (callback) callback(token).then((result)=>{
                    resolve(result);
                }).catch((error)=>{
                    reject(error);
                });
            }).catch((error)=>{
                reject(error);
            });
        });
    });
};
const $2d69ca035e69e29f$var$verify = async (token)=>{
    const response = await fetch(window.akc.services.recaptchaUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            token: token
        })
    });
    const data = await response.json();
    return data.siteVerifyResponse.score <= window.akc.recaptcha.threshold;
};
const $2d69ca035e69e29f$var$checkBot = async (event)=>{
    const action = event.form === "gigya-register-form" ? "sign_up" : event.form === "gigya-login-form" ? "sign_in" : undefined;
    const isBot = await $2d69ca035e69e29f$var$initRecaptcha(action, $2d69ca035e69e29f$var$verify);
    const errors = {
        sign_in: {
            form: "Bot detected: prevent sign in"
        },
        sign_up: {
            form: "Bot detected: prevent sign up"
        }
    };
    if (isBot) return errors[action];
};
gigya.accounts.addEventHandlers({
    onLogin: $2d69ca035e69e29f$var$doMultipass,
    onLogout: ()=>{
        window.localStorage.removeItem("multipassToken");
        window.localStorage.removeItem("customerAccessToken");
        window.localStorage.removeItem("customerAccessTokenExpiresAt");
        window.location.href = window.akc.routes.accountLogoutUrl;
    }
});
// Global session validator - runs on all pages
// session.verify is recommended over getAccountInfo for login checks (lighter weight)
const $2d69ca035e69e29f$var$validateGlobalSession = ()=>{
    gigya.accounts.session.verify({
        callback: (res)=>{
            if (res.errorCode !== 0 && window.localStorage.getItem("multipassToken")) {
                console.warn("Gigya session expired, forcing logout...");
                window.akc.getLogoutScreenset();
            }
        }
    });
};
// Check every 5 minutes if user is still logged in
setInterval($2d69ca035e69e29f$var$validateGlobalSession, 300000);
// Also validate on page visibility change (when tab returns to focus)
document.addEventListener("visibilitychange", ()=>{
    if (document.visibilityState === "visible") $2d69ca035e69e29f$var$validateGlobalSession();
});
window.akc.getRegisterScreenset = (options)=>{
    window.loginReturnTo = options?.returnTo || window.location.href;
    window.gigya.accounts.showScreenSet({
        screenSet: "Login-web-2",
        startScreen: "gigya-register-screen",
        mobileScreenSet: "Login-web-2",
        onBeforeValidation: (e)=>$2d69ca035e69e29f$var$checkBot(e)
    });
};
window.akc.getLoginScreenset = (options)=>{
    window.loginReturnTo = options?.returnTo || window.location.href;
    if (window.location.pathname === window.akc.routes.cartUrl) window.loginReturnTo = window.akc.routes.cartUrl;
    window.gigya.accounts.showScreenSet({
        screenSet: "Login-web-2",
        startScreen: "gigya-login-screen",
        mobileScreenSet: "Login-web-2",
        onBeforeValidation: (e)=>$2d69ca035e69e29f$var$checkBot(e)
    });
};
window.akc.getLogoutScreenset = ()=>{
    window.localStorage.removeItem("multipassToken");
    window.localStorage.removeItem("customerAccessToken");
    window.localStorage.removeItem("customerAccessTokenExpiresAt");
    let currentPageURL = window.location.href;
    let redirectToCurrentPage = (response)=>{
        window.localStorage.setItem("logoutResponse", JSON.stringify(response));
        (0, $c261a752fa03fc9c$export$7cb6f4d3b4eaa9bb)();
        if (response.errorCode == 0) setTimeout(()=>{
            window.location.href = currentPageURL;
            (0, $c261a752fa03fc9c$export$504da2283d222aed)();
        }, 1000); // 1000ms delay prevent redirect before logout fully completes
        else alert("Error :" + response.errorMessage);
    };
    window.gigya.accounts.logout({
        callback: redirectToCurrentPage
    });
};



// Shopify.formatMoney was previously provided by api.jquery.js — polyfill if absent
// https://help.shopify.com/en/manual/international/pricing/currency-formatting
if (window.Shopify && !Shopify.formatMoney) Shopify.formatMoney = function(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || Shopify.money_format || "$ {{amount}}";
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision == null ? 2 : precision;
        thousands = thousands || ",";
        decimal = decimal || ".";
        if (isNaN(number) || number == null) return 0;
        number = (number / 100).toFixed(precision);
        const parts = number.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        const pennies = parts[1] ? decimal + parts[1] : "";
        return dollars + pennies;
    }
    const match = formatString.match(placeholderRegex);
    let value = "";
    switch(match && match[1]){
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
        case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
        case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ",");
            break;
        case "amount_with_period_and_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
        default:
            value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
};


parcelRequire("2x8QE");
var $gD9Ug = parcelRequire("gD9Ug");
const $6815436b0146753e$var$initPromoSlider = ()=>{
    const devices = [
        "desktop",
        "mobile"
    ];
    devices.forEach((device)=>{
        const swiperSelector = `#promo-bar.${device} .promo-bar__swiper`;
        const container = document.querySelector(swiperSelector);
        if (container) $6815436b0146753e$var$setupSwiper(container, device, swiperSelector);
    });
};
const $6815436b0146753e$var$setupSwiper = (container, device, selector)=>{
    const slides = container.querySelectorAll(".swiper-slide");
    const promoBar = container.closest("#promo-bar");
    // fall back to the first slide's background color if not set
    const firstSlide = slides[0];
    const defaultBg = firstSlide?.style.backgroundColor;
    const autoScrollEnabled = container.getAttribute("data-auto-scroll") === "true";
    const scrollSpeed = parseInt(container.getAttribute("data-auto-scroll-speed"), 10) * 1000;
    const config = {
        loop: slides.length > 1,
        slidesPerView: 1,
        centerSlides: true,
        centerSlidesBounds: true,
        allowTouchMove: device === "mobile",
        autoplay: autoScrollEnabled && slides.length > 1 ? {
            delay: scrollSpeed,
            disableOnInteraction: false
        } : false,
        on: {
            init (swiper) {
                if (defaultBg) promoBar.style.backgroundColor = defaultBg;
            },
            slideChange (swiper) {
                const activeSlide = swiper.slides[swiper.activeIndex];
                const bg = activeSlide?.style.backgroundColor || defaultBg;
                if (bg) promoBar.style.backgroundColor = bg;
            }
        }
    };
    let swiper = new (0, $gD9Ug.default)(container, config);
    if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", (evt)=>{
            if (evt.detail.sectionId === "promo-bar") {
                const newContainer = evt.target.querySelector(selector);
                if (newContainer) swiper = new (0, $gD9Ug.default)(newContainer, config);
            }
        });
        document.addEventListener("shopify:section:unload", (evt)=>{
            if (evt.detail.sectionId === "promo-bar") swiper.destroy();
        });
        document.addEventListener("shopify:block:select", (evt)=>{
            const block = evt.target;
            const index = Array.from(block.parentNode.children).indexOf(block);
            if (evt.detail.load) swiper = new (0, $gD9Ug.default)(selector, {
                initialSlide: index,
                ...config
            });
            else swiper.slideTo(index);
        });
    }
};
$6815436b0146753e$var$initPromoSlider();


document.addEventListener("DOMContentLoaded", ()=>{
    $e6e05e78e704e8da$var$initBreedChooser();
    $e6e05e78e704e8da$var$initHeaderBreedRandomizer();
});
const $e6e05e78e704e8da$var$initBreedChooser = ()=>{
    document.querySelectorAll(".breed-chooser").forEach((el)=>{
        Object.assign(el.style, {
            display: "block",
            padding: "10px 0 0 0",
            borderBottom: "none"
        });
    });
    document.querySelectorAll(".breed-chooser select").forEach((el)=>{
        el.style.display = "";
    });
    document.querySelectorAll(".breed-chooser").forEach((el)=>{
        const inner = el.closest(".inner");
        if (inner) inner.style.paddingLeft = "0px";
    });
    document.querySelectorAll(".breed-chooser select").forEach((select)=>{
        select.addEventListener("change", function() {
            window.location.href = this.value;
        });
    });
};
const $e6e05e78e704e8da$var$initHeaderBreedRandomizer = ()=>{
    const breedSelectorImages = document.getElementById("header-breed-selector-images");
    if (!breedSelectorImages) return;
    const imgs = breedSelectorImages.querySelectorAll("img");
    const img = imgs[Math.floor(Math.random() * imgs.length)];
    if (!img) return;
    const breedName = img.getAttribute("data-breed-name");
    const selectEl = document.querySelector("#header-breed-selector .breed-chooser select");
    if (!selectEl) return;
    const option = selectEl.querySelector(`option[data-breed-name="${breedName}"]`);
    if (option) option.selected = true;
    setTimeout(()=>{
        const link = img.closest("a");
        if (link) link.href = selectEl.value;
        img.style.display = "";
        img.style.opacity = "1";
    }, 500);
};


document.addEventListener("DOMContentLoaded", ()=>{
    const accountMenu = document.querySelector(".header__account-menu");
    if (!accountMenu || !accountMenu.querySelector(".header__account-dropdown")) return;
    let hideTimer = null;
    const cancelHide = ()=>clearTimeout(hideTimer);
    const scheduleHide = ()=>{
        cancelHide();
        hideTimer = setTimeout(()=>accountMenu.classList.remove("is-open"), 4000);
    };
    accountMenu.addEventListener("mouseenter", ()=>{
        cancelHide();
        accountMenu.classList.add("is-open");
    });
    accountMenu.addEventListener("mouseleave", scheduleHide);
    document.addEventListener("click", (e)=>{
        if (!accountMenu.contains(e.target)) {
            cancelHide();
            accountMenu.classList.remove("is-open");
        }
    });
});


// Vanilla dropdown class — used by header-nav-desktop.js
class $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc {
    static _active = null;
    static _hideActive() {
        if ($ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._active) $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._active.hide();
    }
    constructor(el, opts = {}){
        this.el = el;
        this.options = Object.assign({
            trigger: null,
            displayEvent: "click",
            hideDelay: 3000,
            mouseLeaveDelay: 500,
            toggledClass: "active",
            showCallback: ()=>{},
            hideCallback: ()=>{},
            dismissOnDocumentClick: true
        }, opts);
        this._hideTimer = null;
        this._mouseLeaveTimer = null;
        this._init();
    }
    _init() {
        const { mouseLeaveDelay: mouseLeaveDelay, trigger: trigger, displayEvent: displayEvent } = this.options;
        if (mouseLeaveDelay) {
            this.el.addEventListener("mouseleave", (e)=>{
                // ignore mouseleave fired by opening a <select> inside the dropdown
                if (e.target.tagName === "SELECT" && this.el.contains(e.target)) return;
                this._mouseLeaveTimer = setTimeout(()=>this.hide(), mouseLeaveDelay);
            });
            this.el.addEventListener("mouseenter", ()=>this._clearTimers());
        }
        if (trigger) {
            const triggerEls = trigger instanceof Element ? [
                trigger
            ] : [
                ...document.querySelectorAll(trigger)
            ];
            triggerEls.forEach((t)=>{
                t.addEventListener(displayEvent, (e)=>{
                    e.preventDefault();
                    if ($ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._active !== this) {
                        e.stopPropagation();
                        this.show();
                    }
                });
            });
        }
        if (!$ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._documentListenerAdded) {
            document.addEventListener("click", (e)=>{
                if ($ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._active && $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._active.options.dismissOnDocumentClick && !$ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._active.el.contains(e.target) && e.target !== $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._active.el) $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._active.hide();
            });
            $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._documentListenerAdded = true;
        }
    }
    _clearTimers() {
        clearTimeout(this._hideTimer);
        clearTimeout(this._mouseLeaveTimer);
    }
    show() {
        if (this.el.classList.contains(this.options.toggledClass)) return;
        if (this.options.hideDelay) this._hideTimer = setTimeout(()=>this.hide(), this.options.hideDelay);
        $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._hideActive();
        $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._active = this;
        this.el.classList.add(this.options.toggledClass);
        this.options.showCallback();
    }
    hide() {
        if (!this.el.classList.contains(this.options.toggledClass)) return;
        $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._active = null;
        this._clearTimers();
        this.el.classList.remove(this.options.toggledClass);
        this.options.hideCallback();
    }
    destroy() {
        this._clearTimers();
    // listeners are anonymous — caller is responsible for element removal
    }
}
$ea272dcc3ea2d0d1$export$931cbfb6bfb85fc._documentListenerAdded = false;


const $3207aa6e443b8523$var$navCategoryNoDropdown = document.querySelectorAll(".main-menu__nav__category:not([data-menu-id])");
const $3207aa6e443b8523$var$parent = document.querySelector(".main-menu__dropdowns");
const $3207aa6e443b8523$var$overlayBackground = document.querySelector(".site-wrap__overlay");
document.querySelectorAll(".main-menu__dropdown").forEach((el)=>{
    const id = el.id;
    const trigger = document.querySelector(`[data-menu-id="${id}"]`);
    if (!trigger) return;
    new (0, $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc)(el, {
        trigger: trigger,
        displayEvent: "mouseover",
        toggledClass: "is-open",
        hideDelay: null,
        mouseLeaveDelay: 1,
        showCallback () {
            el.classList.remove("is-closing");
            document.querySelectorAll(".main-menu__dropdown").forEach((s)=>{
                if (s !== el) s.classList.remove("is-closing");
            });
            $3207aa6e443b8523$var$parent?.classList.add("is-open");
            trigger.classList.add("is-open");
            $3207aa6e443b8523$var$overlayBackground?.classList.add("is-open");
        },
        hideCallback () {
            $3207aa6e443b8523$var$parent?.classList.remove("is-open");
            trigger.classList.remove("is-open");
            if (!$3207aa6e443b8523$var$parent?.classList.contains("is-open")) {
                el.classList.add("is-closing");
                $3207aa6e443b8523$var$overlayBackground?.classList.remove("is-open");
            }
        }
    });
});
$3207aa6e443b8523$var$navCategoryNoDropdown.forEach((cat)=>{
    cat.addEventListener("mouseover", ()=>(0, $ea272dcc3ea2d0d1$export$931cbfb6bfb85fc)._active?.hide());
});


var $699482c066c50474$exports = {};
/**
 * Accordion v3.4.1
 * Lightweight and accessible accordion module created in pure Javascript
 * https://github.com/michu2k/Accordion
 *
 * Copyright (c) Michał Strumpf
 * Published under MIT License
 */ "use strict";
!function(e) {
    let t = 0;
    const s = function(e, n) {
        const i = "js-enabled", o = this;
        let r = !1;
        if (Array.isArray(e)) return !!e.length && e.map((e)=>new s(e, n));
        const l = {
            init () {
                this.options = Object.assign({
                    duration: 500,
                    ariaEnabled: !0,
                    collapse: !0,
                    showMultiple: !1,
                    onlyChildNodes: !0,
                    openOnInit: [],
                    elementClass: "ac",
                    triggerClass: "ac-trigger",
                    panelClass: "ac-panel",
                    activeClass: "is-active",
                    beforeOpen: ()=>{},
                    onOpen: ()=>{},
                    beforeClose: ()=>{},
                    onClose: ()=>{}
                }, n);
                const t = "string" == typeof e;
                this.container = t ? document.querySelector(e) : e, this.createDefinitions(), o.attachEvents();
            },
            createDefinitions () {
                const { elementClass: e, openOnInit: s, onlyChildNodes: n } = this.options, o = n ? this.container.childNodes : this.container.querySelectorAll(a(e));
                this.elements = Array.from(o).filter((t)=>t.classList && t.classList.contains(e)), this.firstElement = this.elements[0], this.lastElement = this.elements[this.elements.length - 1], this.elements.filter((e)=>!e.classList.contains(i)).forEach((e)=>{
                    e.classList.add(i), this.generateIDs(e), this.setARIA(e), this.setTransition(e);
                    const n = this.elements.indexOf(e);
                    t++, s.includes(n) ? this.showElement(e, !1) : this.closeElement(e, !1);
                });
            },
            setTransition (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                const { duration: s, panelClass: n } = this.options;
                e.querySelector(a(n)).style.transitionDuration = t ? null : "".concat(s, "ms");
            },
            generateIDs (e) {
                const { triggerClass: s, panelClass: n } = this.options, i = e.querySelector(a(s)), o = e.querySelector(a(n));
                e.setAttribute("id", e.id || "ac-".concat(t)), i.setAttribute("id", i.id || "ac-trigger-".concat(t)), o.setAttribute("id", o.id || "ac-panel-".concat(t));
            },
            removeIDs (e) {
                const { triggerClass: t, panelClass: s } = this.options, n = e.querySelector(a(t)), i = e.querySelector(a(s));
                e.id.startsWith("ac-") && e.removeAttribute("id"), n.id.startsWith("ac-") && n.removeAttribute("id"), i.id.startsWith("ac-") && i.removeAttribute("id");
            },
            setARIA (e) {
                const { ariaEnabled: t, triggerClass: s, panelClass: n } = this.options;
                if (!t) return;
                const i = e.querySelector(a(s)), o = e.querySelector(a(n));
                i.setAttribute("role", "button"), i.setAttribute("aria-controls", o.id), i.setAttribute("aria-disabled", !1), i.setAttribute("aria-expanded", !1), o.setAttribute("role", "region"), o.setAttribute("aria-labelledby", i.id);
            },
            updateARIA (e, t) {
                let { ariaExpanded: s, ariaDisabled: n } = t;
                const { ariaEnabled: i, triggerClass: o } = this.options;
                if (!i) return;
                const r = e.querySelector(a(o));
                r.setAttribute("aria-expanded", s), r.setAttribute("aria-disabled", n);
            },
            removeARIA (e) {
                const { ariaEnabled: t, triggerClass: s, panelClass: n } = this.options;
                if (!t) return;
                const i = e.querySelector(a(s)), o = e.querySelector(a(n));
                i.removeAttribute("role"), i.removeAttribute("aria-controls"), i.removeAttribute("aria-disabled"), i.removeAttribute("aria-expanded"), o.removeAttribute("role"), o.removeAttribute("aria-labelledby");
            },
            focus (e, t) {
                e.preventDefault();
                const { triggerClass: s } = this.options;
                t.querySelector(a(s)).focus();
            },
            focusFirstElement (e) {
                this.focus(e, this.firstElement), this.currFocusedIdx = 0;
            },
            focusLastElement (e) {
                this.focus(e, this.lastElement), this.currFocusedIdx = this.elements.length - 1;
            },
            focusNextElement (e) {
                const t = this.currFocusedIdx + 1;
                if (t > this.elements.length - 1) return this.focusFirstElement(e);
                this.focus(e, this.elements[t]), this.currFocusedIdx = t;
            },
            focusPrevElement (e) {
                const t = this.currFocusedIdx - 1;
                if (t < 0) return this.focusLastElement(e);
                this.focus(e, this.elements[t]), this.currFocusedIdx = t;
            },
            showElement (e) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                const { panelClass: s, activeClass: n, collapse: i, beforeOpen: o } = this.options;
                t && o(e);
                const r = e.querySelector(a(s)), l = r.scrollHeight;
                e.classList.add(n), requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        r.style.height = t ? "".concat(l, "px") : "auto";
                    });
                }), this.updateARIA(e, {
                    ariaExpanded: !0,
                    ariaDisabled: !i
                });
            },
            closeElement (e) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                const { panelClass: s, activeClass: n, beforeClose: i } = this.options, o = e.querySelector(a(s)), r = o.scrollHeight;
                e.classList.remove(n), t ? (i(e), requestAnimationFrame(()=>{
                    o.style.height = "".concat(r, "px"), requestAnimationFrame(()=>{
                        o.style.height = 0;
                    });
                })) : o.style.height = 0, this.updateARIA(e, {
                    ariaExpanded: !1,
                    ariaDisabled: !1
                });
            },
            toggleElement (e) {
                const { activeClass: t, collapse: s } = this.options, n = e.classList.contains(t);
                if (!n || s) return n ? this.closeElement(e) : this.showElement(e);
            },
            closeElements () {
                const { activeClass: e, showMultiple: t } = this.options;
                t || this.elements.forEach((t, s)=>{
                    t.classList.contains(e) && s !== this.currFocusedIdx && this.closeElement(t);
                });
            },
            handleClick (e) {
                const t = e.currentTarget;
                this.elements.forEach((s, n)=>{
                    s.contains(t) && "A" !== e.target.nodeName && (this.currFocusedIdx = n, this.closeElements(), this.focus(e, s), this.toggleElement(s));
                });
            },
            handleKeydown (e) {
                switch(e.key){
                    case "ArrowUp":
                        return this.focusPrevElement(e);
                    case "ArrowDown":
                        return this.focusNextElement(e);
                    case "Home":
                        return this.focusFirstElement(e);
                    case "End":
                        return this.focusLastElement(e);
                    default:
                        return null;
                }
            },
            handleFocus (e) {
                const t = e.currentTarget, s = this.elements.find((e)=>e.contains(t));
                this.currFocusedIdx = this.elements.indexOf(s);
            },
            handleTransitionEnd (e) {
                if (e.stopPropagation(), "height" !== e.propertyName) return;
                const { onOpen: t, onClose: s } = this.options, n = e.currentTarget, i = parseInt(n.style.height), o = this.elements.find((e)=>e.contains(n));
                i > 0 ? (n.style.height = "auto", t(o)) : s(o);
            }
        };
        this.attachEvents = ()=>{
            if (r) return;
            const { triggerClass: e, panelClass: t } = l.options;
            l.handleClick = l.handleClick.bind(l), l.handleKeydown = l.handleKeydown.bind(l), l.handleFocus = l.handleFocus.bind(l), l.handleTransitionEnd = l.handleTransitionEnd.bind(l), l.elements.forEach((s)=>{
                const n = s.querySelector(a(e)), i = s.querySelector(a(t));
                n.addEventListener("click", l.handleClick), n.addEventListener("keydown", l.handleKeydown), n.addEventListener("focus", l.handleFocus), i.addEventListener("transitionend", l.handleTransitionEnd);
            }), r = !0;
        }, this.detachEvents = ()=>{
            if (!r) return;
            const { triggerClass: e, panelClass: t } = l.options;
            l.elements.forEach((s)=>{
                const n = s.querySelector(a(e)), i = s.querySelector(a(t));
                n.removeEventListener("click", l.handleClick), n.removeEventListener("keydown", l.handleKeydown), n.removeEventListener("focus", l.handleFocus), i.removeEventListener("transitionend", l.handleTransitionEnd);
            }), r = !1;
        }, this.toggle = (e)=>{
            const t = l.elements[e];
            t && l.toggleElement(t);
        }, this.open = (e)=>{
            const t = l.elements[e];
            t && l.showElement(t);
        }, this.openAll = ()=>{
            const { activeClass: e, onOpen: t } = l.options;
            l.elements.forEach((s)=>{
                s.classList.contains(e) || (l.showElement(s, !1), t(s));
            });
        }, this.close = (e)=>{
            const t = l.elements[e];
            t && l.closeElement(t);
        }, this.closeAll = ()=>{
            const { activeClass: e, onClose: t } = l.options;
            l.elements.forEach((s)=>{
                s.classList.contains(e) && (l.closeElement(s, !1), t(s));
            });
        }, this.destroy = ()=>{
            this.detachEvents(), this.openAll(), l.elements.forEach((e)=>{
                l.removeIDs(e), l.removeARIA(e), l.setTransition(e, !0), e.classList.remove(i);
            }), r = !0;
        }, this.update = ()=>{
            l.createDefinitions(), this.detachEvents(), this.attachEvents();
        };
        const a = (e)=>".".concat(CSS.escape(e));
        l.init();
    };
    void 0 !== $699482c066c50474$exports ? $699482c066c50474$exports = s : e.Accordion = s;
}(window);


// Event delegation — no timing dependency, works regardless of when script runs
document.addEventListener("click", (e)=>{
    if (!e.target.closest(".mobile-header__menu-icon")) return;
    const navTrigger = document.querySelector(".mobile-header__menu-icon");
    const navWrap = document.querySelector(".mobile-header__wrap");
    const dropdownsWrap = document.querySelector(".main-menu-mobile__dropdowns");
    const searchTrigger = document.querySelector(".mobile-header__search");
    const searchWrap = document.querySelector(".mobile-header__search-bar");
    searchTrigger?.classList.remove("is-open");
    searchWrap?.classList.remove("is-open");
    const isOpen = navTrigger.classList.contains("is-open");
    navTrigger.classList.toggle("is-open", !isOpen);
    navWrap?.classList.toggle("is-open", !isOpen);
    dropdownsWrap?.classList.toggle("is-open", !isOpen);
});
const $26925752997d7676$var$searchTrigger = document.querySelector(".mobile-header__search");
const $26925752997d7676$var$searchWrap = document.querySelector(".mobile-header__search-bar");
$26925752997d7676$var$searchTrigger?.addEventListener("click", ()=>{
    const navTrigger = document.querySelector(".mobile-header__menu-icon");
    const navWrap = document.querySelector(".mobile-header__wrap");
    const dropdownsWrap = document.querySelector(".main-menu-mobile__dropdowns");
    navTrigger?.classList.remove("is-open");
    navWrap?.classList.remove("is-open");
    dropdownsWrap?.classList.remove("is-open");
    $26925752997d7676$var$searchTrigger.classList.toggle("is-open");
    $26925752997d7676$var$searchWrap?.classList.toggle("is-open");
});
const $26925752997d7676$var$subcategoryDropdowns = [
    ...document.querySelectorAll(".main-menu-mobile__dropdown")
].filter((dropdown)=>dropdown.querySelector(".main-menu-mobile__subcategory-wrap--has-dropdown")).map((dropdown)=>({
        el: dropdown,
        accordion: new (0, (/*@__PURE__*/$parcel$interopDefault($699482c066c50474$exports)))(dropdown, {
            elementClass: "main-menu-mobile__subcategory-wrap--has-dropdown",
            triggerClass: "main-menu-mobile__dropdown__subcategory-icon",
            panelClass: "main-menu-mobile__dropdown__subcategory-items",
            activeClass: "is-open"
        })
    }));
new (0, (/*@__PURE__*/$parcel$interopDefault($699482c066c50474$exports)))(".main-menu-mobile__dropdowns", {
    elementClass: "main-menu-mobile__dropdown-wrap--has-dropdown",
    triggerClass: "main-menu-mobile__category-icon",
    panelClass: "main-menu-mobile__dropdown",
    activeClass: "is-open",
    beforeClose: (el)=>{
        const panelId = el.id.split("-").join("-panel-");
        const subcategoryDropdown = $26925752997d7676$var$subcategoryDropdowns.find((dropdown)=>dropdown.el.id === panelId);
        if (!subcategoryDropdown) return;
        subcategoryDropdown.accordion.closeAll();
        // Below we are manually toggling false aria-expanded's due to a bug with
        // manually closing dropdowns with accordion-js
        const expandedAreas = [
            ...subcategoryDropdown.el.querySelectorAll('[aria-expanded="true"]')
        ];
        if (expandedAreas) expandedAreas.forEach((expanded)=>expanded.setAttribute("aria-expanded", false));
    }
});



var $6Ny6s = parcelRequire("6Ny6s");
class $b11afca3a6ee5106$var$CartMessage extends HTMLElement {
    constructor(){
        super();
        this._onTransitionEnd = this._onTransitionEnd.bind(this);
        this._isOpen = false;
        this.message = document.getElementById("cart-message");
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.message.addEventListener("keyup", (evt)=>evt.code === "Escape" && this.closest());
        this.querySelectorAll('button[type="button"]').forEach((closeButton)=>closeButton.addEventListener("click", this.closest.bind(this)));
        this._timeout = null;
    }
    /**
     * Opens the message
     */ open() {
        this._resetTimeout();
        // If already open, reset the animation so it can appear when spammed
        if (this._isOpen) {
            this.message.classList.remove("animate", "active");
            // Force reflow to allow re-triggering the animation
            this.message.offsetWidth;
        }
        this._isOpen = true;
        // Remove any previous transitionend event listener to prevent stacking or duplicate
        this.message.removeEventListener("transitionend", this._onTransitionEnd);
        // Show modal
        this.message.classList.add("animate", "active");
        this.message.style.display = "block";
        // Add a new transitionend event listener to handle focus and accessibility after the animation
        this.message.addEventListener("transitionend", this._onTransitionEnd);
        // Set up an event listener on the document body to detect clicks
        document.body.addEventListener("click", this.onBodyClick);
        // Set up an event listener on the message to detect interactions and reset the timeout
        this.message.addEventListener("mousemove", this._resetTimeout.bind(this));
        this.message.addEventListener("click", this._resetTimeout.bind(this));
        this.message.addEventListener("keydown", this._resetTimeout.bind(this));
    }
    /**
     * Handles the transition ends to ensure that focus is set correctly
     */ _onTransitionEnd() {
        // Once the transition (animation) is complete, set the focus to the message element
        this.message.focus();
        // Ensure that keyboard focus remains within the message for better accessibility
        trapFocus(this.message);
    }
    /**
     * Closes the message
     */ close() {
        // Remove the 'active' class from the message
        this.message.classList.remove("active");
        this.message.style.display = "none";
        // Remove the previously added click event listener from the document body, ensuring that it won't interfere with other interactions after the message is closed
        document.body.removeEventListener("click", this.onBodyClick);
        // More clean-up to prevent any stacking of event listeners
        this.message.removeEventListener("transitionend", this._onTransitionEnd);
        // Clear the timeout
        if (this._timeout) clearTimeout(this._timeout);
        this._isOpen = false;
    }
    /**
     * Render the contents of a component (e.g., a cart) based on a given state
     *
     * @param {Object} parsedState - The state data used to update the content
     */ renderContents(parsedState) {
        this.cartItemKey = parsedState.key;
        this.getSectionsToRender().forEach((section)=>{
            document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
        // Set event listeners for quantity selector
        const productType = parsedState.product_type;
        const quantitySelector = document.querySelector(".quantity-selector");
        const minusButton = quantitySelector.querySelector(".quantity-selector__button.minus");
        const plusButton = quantitySelector.querySelector(".quantity-selector__button.plus");
        const quantityInput = quantitySelector.querySelector('input[type="number"]');
        if (productType === "Report") quantitySelector.style.display = "none";
        minusButton.addEventListener("click", ()=>{
            $b11afca3a6ee5106$var$updateItemQuantity(this.cartItemKey, "decrement");
        });
        plusButton.addEventListener("click", ()=>{
            $b11afca3a6ee5106$var$updateItemQuantity(this.cartItemKey, "increment");
        });
        quantityInput.addEventListener("input", ()=>{
            $b11afca3a6ee5106$var$updateQuantity(this.cartItemKey);
        });
        // Set the initial state of the minus button based on the quantity
        const initialQuantity = document.getElementById(`quantity-input-${this.cartItemKey}`).value;
        this._updateMinusButtonState(this.cartItemKey, initialQuantity);
        this.open();
        (0, $6Ny6s.showAddToCartPreview)(this.cartItemKey);
    }
    // New method to update the minus button state
    _updateMinusButtonState(itemKey, quantity) {
        const minusButton = document.getElementById(`minus-button-${itemKey}`);
        if (minusButton) minusButton.disabled = quantity <= 1;
    }
    /**
     * Returns an array of sections that need to be rendered or updated.
     * Each section is represented by an object containing its unique ID and, optionally, a specific selector.
     *
     * @returns {Array} An array of section objects.
     */ getSectionsToRender() {
        return [
            {
                id: "cart-item",
                selector: `[id="cart-item-${this.cartItemKey}"]`
            }
        ];
    }
    /**
     * Parses a given HTML string, extracts the inner HTML of the element matched by the provided selector,
     * and returns it.
     *
     * @param {string} html - The HTML string to parse and extract content from.
     * @param {string} [selector=] - The CSS selector to match the desired element.
     *
     * @returns {string} The inner HTML of the matched element.
     */ getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }
    /**
     * Handles click events on the body to determine if specific actions (like closing the message) should be taken
     *
     * @param {Event} evt - The click event object
     */ handleBodyClick(evt) {
        // Get the element that was clicked.
        const target = evt.target;
        const closeButton = target.closest(".cart-message__close");
        // Check if the clicked element is NOT the message itself and is also NOT a descendant of 'cart-message'
        if (target !== this.message && !target.closest(".cart-message") || closeButton) // If the clicked element is NOT the message itself and is also NOT a descendant of 'cart-message', close the message
        this.close();
    }
    /**
     * Resets the timeout for closing the message.
     */ _resetTimeout() {
        // Clear any existing timeout
        if (this._timeout) clearTimeout(this._timeout);
        // Set a new timeout to close the message after 3 seconds
        this._timeout = setTimeout(()=>{
            this.close();
        }, 3000);
    }
    setActiveElement(element) {
        this.activeElement = element;
    }
}
async function $b11afca3a6ee5106$var$updateCart(itemKey, quantity) {
    const data = {
        id: itemKey,
        quantity: quantity
    };
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    };
    return fetch("/cart/change.js", options) // Ensure this returns a promise
    .then((response)=>response.json());
}
function $b11afca3a6ee5106$var$getCartTotal() {
    return fetch("/cart.js", {
        cache: "no-store"
    }).then((res)=>res.json()).then((cart)=>cart.original_total_price);
}
async function $b11afca3a6ee5106$var$updateItemQuantity(itemKey, changeType) {
    const input = document.getElementById(`quantity-input-${itemKey}`);
    let quantity = parseInt(input.value, 10);
    if (changeType === "increment") quantity++;
    else if (changeType === "decrement" && quantity > 1) quantity--;
    // Update input value and item total price
    input.value = quantity;
    $b11afca3a6ee5106$var$updateItemTotalPrice(itemKey, quantity);
    // Update cart and wait for it to complete
    await $b11afca3a6ee5106$var$updateCart(itemKey, quantity);
    // Fetch and display updated cart total
    await $b11afca3a6ee5106$var$updateCartTotalDisplay();
}
async function $b11afca3a6ee5106$var$updateCartTotalDisplay() {
    try {
        // Fetch and display updated cart total
        const totalCart = await $b11afca3a6ee5106$var$getCartTotal();
        const cartTotalElement = document.getElementById("cart-total");
        if (cartTotalElement) cartTotalElement.textContent = `Total: ${(0, $6Ny6s.formatMoney)(totalCart)}`;
    } catch (error) {
        console.error("Error fetching cart total:", error);
    }
}
function $b11afca3a6ee5106$var$updateItemTotalPrice(itemKey, quantity) {
    // Get the unit price of the item
    const eachPriceElement = document.getElementById(`item-each-price-${itemKey}`);
    const eachPrice = parseFloat(eachPriceElement.textContent.replace(/[^0-9.-]+/g, ""));
    // Compute the new total price for the item
    const totalPrice = eachPrice * quantity;
    // Update the displayed total price for the item
    const totalPriceElement = document.getElementById(`item-price-${itemKey}`);
    totalPriceElement.textContent = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    }).format(totalPrice);
    const cartMessageElement = document.querySelector("cart-message");
    if (cartMessageElement) cartMessageElement._updateMinusButtonState(itemKey, quantity);
}
async function $b11afca3a6ee5106$var$updateQuantity(itemKey) {
    const input = document.getElementById(`quantity-input-${itemKey}`);
    let quantity = parseInt(input.value, 10);
    if (quantity >= 1) {
        // Update item total price
        $b11afca3a6ee5106$var$updateItemTotalPrice(itemKey, quantity);
        // Update cart and wait for it to complete
        await $b11afca3a6ee5106$var$updateCart(itemKey, quantity);
        // After updating the cart, fetch and display updated cart total
        try {
            const totalCartElement = document.getElementById("cart-message-product__price-total");
            const totalCart = await $b11afca3a6ee5106$var$getCartTotal();
            let totalCartInDollars = totalCart / 100;
            totalCartElement.textContent = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(totalCartInDollars);
        } catch (error) {
            console.error("Error fetching cart total:", error);
        }
    }
}
customElements.define("cart-message", $b11afca3a6ee5106$var$CartMessage);


parcelRequire("2x8QE");
var $gD9Ug = parcelRequire("gD9Ug");
window.customElements.define("hero-full-banner", class HeroFullBanner extends HTMLElement {
    constructor(){
        super();
        const autoScroll = this.dataset.autoScroll === "true";
        const autoScrollSpeed = parseInt(this.dataset.autoScrollSpeed, 10) * 1000;
        const config = {
            slidesPerView: 1,
            pagination: {
                el: this.querySelector(".swiper-pagination")
            },
            navigation: {
                nextEl: this.querySelector(".swiper-button-next"),
                prevEl: this.querySelector(".swiper-button-prev")
            },
            autoplay: autoScroll ? {
                delay: autoScrollSpeed,
                disableOnInteraction: false
            } : false
        };
        let swiper = new (0, $gD9Ug.default)(this.querySelector(".swiper-container"), config);
        if (Shopify.designMode) {
            document.addEventListener("shopify:section:load", ()=>{
                swiper = new (0, $gD9Ug.default)(this.querySelector(".swiper-container"), config);
            });
            document.addEventListener("shopify:section:unload", ()=>{
                swiper.destroy();
            });
            document.addEventListener("shopify:block:select", (evt)=>{
                if (!this.contains(evt.target)) return;
                const index = Array.prototype.indexOf.call(evt.target.parentNode.children, evt.target);
                swiper.slideTo(index);
            });
        }
    }
});


parcelRequire("2x8QE");
var $gD9Ug = parcelRequire("gD9Ug");
window.customElements.define("hero-multi-banner", class HeroMultiBanner extends HTMLElement {
    constructor(){
        super();
        const autoScroll = this.dataset.autoScroll === "true";
        const autoScrollSpeed = parseInt(this.dataset.autoScrollSpeed, 10) * 1000;
        const slideCount = this.querySelectorAll(".swiper-slide").length;
        const config = {
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    spaceBetween: 32
                }
            },
            loop: slideCount > 1,
            pagination: {
                el: this.querySelector(".swiper-pagination"),
                clickable: true
            },
            navigation: {
                nextEl: this.querySelector(".swiper-button-next"),
                prevEl: this.querySelector(".swiper-button-prev")
            },
            autoplay: autoScroll ? {
                delay: autoScrollSpeed,
                disableOnInteraction: false
            } : false
        };
        let swiper = new (0, $gD9Ug.default)(this.querySelector(".swiper-container"), config);
        if (Shopify.designMode) {
            document.addEventListener("shopify:section:load", ()=>{
                swiper = new (0, $gD9Ug.default)(this.querySelector(".swiper-container"), config);
            });
            document.addEventListener("shopify:section:unload", ()=>{
                swiper.destroy();
            });
            document.addEventListener("shopify:block:select", (evt)=>{
                if (!this.contains(evt.target)) return;
                const index = Array.prototype.indexOf.call(evt.target.parentNode.children, evt.target);
                if (config.loop) swiper.slideToLoop(index);
                else swiper.slideTo(index);
            });
        }
    }
});


parcelRequire("2x8QE");
var $gD9Ug = parcelRequire("gD9Ug");
window.customElements.define("hero-half-banner", class HeroHalfBanner extends HTMLElement {
    constructor(){
        super();
        const autoScroll = this.dataset.autoScroll === "true";
        const autoScrollSpeed = parseInt(this.dataset.autoScrollSpeed, 10) * 1000;
        const config = {
            slidesPerView: 1,
            pagination: {
                el: this.querySelector(".swiper-pagination")
            },
            navigation: {
                nextEl: this.querySelector(".swiper-button-next"),
                prevEl: this.querySelector(".swiper-button-prev")
            },
            autoplay: autoScroll ? {
                delay: autoScrollSpeed,
                disableOnInteraction: false
            } : false
        };
        let swiper = new (0, $gD9Ug.default)(this.querySelector(".swiper-container"), config);
        if (Shopify.designMode) {
            document.addEventListener("shopify:section:unload", (evt)=>{
                if (evt.target.contains(this)) swiper.destroy();
            });
            document.addEventListener("shopify:block:select", (evt)=>{
                if (!this.contains(evt.target)) return;
                const index = Array.prototype.indexOf.call(evt.target.parentNode.children, evt.target);
                swiper.slideTo(index);
            });
        }
    }
});



var $6Ny6s = parcelRequire("6Ny6s");
document.addEventListener("DOMContentLoaded", ()=>{
    const cartIcon = document.querySelector(".logo-bar__links #cart-icon");
    const cartWrapper = document.querySelector(".cart-message-wrapper");
    const cartExitButton = document.querySelector(".cart-message__close");
    if (!cartIcon) return;
    let hoverCheckTimeout = null;
    const checkHoverState = ()=>{
        clearTimeout(hoverCheckTimeout);
        hoverCheckTimeout = setTimeout(()=>{
            if (!cartIcon.matches(":hover") && !cartWrapper?.matches(":hover")) (0, $6Ny6s.hideCartModal)();
        }, 250);
    };
    cartIcon.addEventListener("mouseenter", (0, $6Ny6s.showCartHoverPreview));
    cartIcon.addEventListener("mouseleave", checkHoverState);
    cartWrapper?.addEventListener("mouseleave", checkHoverState);
    cartExitButton?.addEventListener("click", (0, $6Ny6s.hideCartModal));
});


window.customElements.define("quantity-selector", class QuantitySelector extends HTMLElement {
    constructor(){
        super();
        this.updateDiscountPrices();
        this.input = this.querySelector('input[type="number"]');
        this.minusButton = this.querySelector('button[name="minus"]');
        this.minValue = parseInt(this.input.min);
        this.changeEvent = new Event("change", {
            bubbles: true
        });
        this.input.addEventListener("change", this.onValueChange.bind(this));
        this.input.addEventListener("keyup", this.onValueChange.bind(this));
        this.querySelectorAll("button").forEach((button)=>button.addEventListener("click", this.onButtonClick.bind(this)));
    }
    onValueChange() {
        if (this.input.value > this.minValue) this.minusButton.removeAttribute("disabled");
        else this.minusButton.setAttribute("disabled", "disabled");
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        const currentButton = event.target.closest(".quantity-selector__button");
        currentButton.name === "plus" ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) {
            this.input.dispatchEvent(this.changeEvent);
            this.updateDiscountPrices();
        }
    }
    updateDiscountPrices() {
        let allocatedAmountSummaryLine = 0;
        document.querySelectorAll(".cart-item-item").forEach((el)=>{
            const quantity = parseFloat(el.querySelector(".input-quantity")?.value);
            const priceText = el.querySelector(".item-original-price")?.textContent ?? "";
            if (priceText === "" || isNaN(quantity)) return;
            const price = parseFloat(priceText.replace(/[^0-9.-]+/g, ""));
            const allocatedAmount = quantity * price;
            const allocatedEl = el.querySelector(".total-original-allocated-amount");
            if (allocatedEl) allocatedEl.textContent = "$" + allocatedAmount.toFixed(2);
            allocatedAmountSummaryLine = allocatedAmount;
        });
        const totalEl = document.querySelector(".total-allocated-amount");
        if (totalEl) totalEl.textContent = "$" + allocatedAmountSummaryLine.toFixed(2);
    }
});


parcelRequire("2x8QE");
var $gD9Ug = parcelRequire("gD9Ug");
window.customElements.define("product-carousel", class ProductCarousel extends HTMLElement {
    constructor(){
        super();
        const config = {
            slidesPerView: 1.5,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                1024: {
                    slidesPerView: 3.5
                },
                1280: {
                    slidesPerView: 4.5
                }
            },
            pagination: {
                el: ".swiper-pagination"
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        };
        let swiper = new (0, $gD9Ug.default)(this, config);
        if (Shopify.designMode) {
            document.addEventListener("shopify:section:load", ()=>{
                swiper = new (0, $gD9Ug.default)(this, config);
            });
            document.addEventListener("shopify:section:unload", ()=>{
                swiper.destroy();
            });
        }
    }
});


parcelRequire("2x8QE");
var $gD9Ug = parcelRequire("gD9Ug");

window.customElements.define("curated-collection", class CuratedCollection extends HTMLElement {
    constructor(){
        super();
        this.handleQuickShopClick = this.handleQuickShopClick.bind(this);
    }
    connectedCallback() {
        this.addEventListener("click", this.handleQuickShopClick, true);
        const tabs = Array.from(this.querySelectorAll(".curated-collection__tab"));
        const panels = Array.from(this.querySelectorAll(".curated-collection__panel"));
        const links = Array.from(this.querySelectorAll(".curated-collection__view-more"));
        const activate = (index)=>{
            tabs.forEach((t)=>t.classList.toggle("is-active", t.dataset.tab === index));
            panels.forEach((p)=>p.classList.toggle("is-hidden", p.dataset.tabPanel !== index));
            links.forEach((l)=>l.classList.toggle("is-hidden", l.dataset.tabLink !== index));
            window.dispatchEvent(new Event("resize"));
        };
        tabs.forEach((tab)=>{
            tab.addEventListener("click", ()=>activate(tab.dataset.tab));
        });
        if (tabs.length) activate(tabs[0].dataset.tab);
        const swiperConfig = {
            slidesPerView: 2.2,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                1024: {
                    slidesPerView: 3.5
                },
                1280: {
                    slidesPerView: "auto"
                }
            },
            pagination: {
                el: ".swiper-pagination"
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        };
        const initSwipers = ()=>Array.from(this.querySelectorAll(".product-carousel.swiper-container")).map((carousel)=>new (0, $gD9Ug.default)(carousel, swiperConfig));
        let swipers = initSwipers();
        if (Shopify.designMode) {
            document.addEventListener("shopify:section:load", ()=>{
                swipers = initSwipers();
            });
            document.addEventListener("shopify:section:unload", ()=>{
                swipers.forEach((swiper)=>swiper.destroy());
            });
        }
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.handleQuickShopClick, true);
    }
    async handleQuickShopClick(event) {
        const button = event.target.closest(".card-v2 .quickshop-btn");
        if (!button) return;
        const card = button.closest(".card-v2");
        if (!card) return;
        event.preventDefault();
        event.stopPropagation();
        const { renderQuickShop: renderQuickShop } = await (parcelRequire("47e0r"));
        renderQuickShop(card);
    }
});


var $428fcb2015744f49$exports = {};
(function(global, factory) {
    $428fcb2015744f49$exports = factory();
})($428fcb2015744f49$exports, function() {
    "use strict";
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === "__proto__") continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    return api;
});


window.customElements.define("recently-viewed-products", class RecentlyViewedProducts extends HTMLElement {
    constructor(){
        super();
        this.container = this.querySelector("section");
        this.swiperTemplate = this.querySelector("template.recently-viewed-products-swiper-template");
        this.slideTemplate = this.querySelector("template.recently-viewed-products-slide-template");
        this.productHandles = this.getRecentlyViewed();
        this.products = new Array(this.productHandles.length);
        this.init();
    }
    getRecentlyViewed() {
        const products = (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get("recently-viewed-products");
        return products ? JSON.parse(products) : [];
    }
    async init() {
        await this.fetchProducts();
        this.render();
        this.addRecentlyViewed();
    }
    async fetchProducts() {
        if (!this.productHandles.length) return;
        return Promise.all(this.productHandles.map(this.fetchProduct.bind(this)));
    }
    async fetchProduct(productHandle, index) {
        try {
            let res = await fetch(`/products/${productHandle}.js`);
            res = await res.json();
            this.products.splice(index, 1, res);
        } catch (err) {
            console.error(err);
        }
    }
    render() {
        const swiperContainer = this.swiperTemplate.content.cloneNode(true);
        const slidesContainer = swiperContainer.querySelector(".swiper-wrapper");
        const badgeTags = [
            "Sale",
            "New Arrivals",
            "Best Seller"
        ];
        let heading = document.createElement("template");
        heading.innerHTML = `
      <div class="recently-viewed-products__product-carousel-heading">
        <h2>Recently Viewed</h2>
      </div>
    `.trim();
        heading = heading.content;
        this.products.forEach((product)=>{
            const slideContainer = this.slideTemplate.content.cloneNode(true);
            slideContainer.querySelector(".card").href = product.url;
            const slideBadge = slideContainer.querySelector(".card__badge");
            const badgeTag = product.tags.find((tag)=>badgeTags.includes(tag));
            if (badgeTag) {
                const badgeHandle = badgeTag.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
                slideBadge.classList.add(`card__badge--${badgeHandle}`);
                slideBadge.textContent = badgeTag;
            } else slideBadge.remove();
            if (product.featured_image) {
                const imageUrl = new URL(product.featured_image, window.location.origin);
                const ext = imageUrl.pathname.lastIndexOf(".");
                imageUrl.pathname = `${imageUrl.pathname.slice(0, ext)}_200x160${imageUrl.pathname.slice(ext)}`;
                const image = document.createElement("img");
                image.src = imageUrl.toString();
                slideContainer.querySelector(".card__image").appendChild(image);
            }
            slideContainer.querySelector(".card__title").textContent = product.title;
            const price = slideContainer.querySelector(".card__price");
            price.lastChild.textContent = Shopify.formatMoney(product.price);
            if (product.compare_at_price) price.querySelector(".card__compare-price").textContent = Shopify.formatMoney(product.compare_at_price);
            else price.querySelector(".card__compare-price-wrap").remove();
            slideContainer.querySelector(".card__button button").dataset.product = product.handle;
            slidesContainer.appendChild(slideContainer);
        });
        this.container.innerHTML = "";
        this.container.append(heading, swiperContainer);
    }
    addRecentlyViewed() {
        if (!window.location.pathname.includes("/products/")) return;
        let handles = this.productHandles;
        const currentHandle = window.location.pathname.substring(window.location.pathname.lastIndexOf("/products/") + 10);
        if (handles.some((h)=>h === currentHandle)) handles = handles.filter((h)=>h !== currentHandle);
        handles.unshift(currentHandle);
        if (handles.length > 5) handles.pop();
        this.productHandles = handles;
        (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).set("recently-viewed-products", JSON.stringify(this.productHandles));
    }
});


parcelRequire("2x8QE");
var $gD9Ug = parcelRequire("gD9Ug");
window.customElements.define("shop-by-breed", class ShopByBreed extends HTMLElement {
    connectedCallback() {
        const select = this.querySelector(".shop-by-breed__select");
        const carousel = this.querySelector(".shop-by-breed__carousel");
        if (!carousel) return;
        this.swiper = new (0, $gD9Ug.default)(carousel, {
            slidesPerView: "auto",
            spaceBetween: 16,
            pagination: {
                el: this.querySelector(".shop-by-breed__pagination"),
                clickable: true
            },
            navigation: {
                nextEl: this.querySelector(".shop-by-breed__next"),
                prevEl: this.querySelector(".shop-by-breed__previous")
            },
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 16
                },
                1024: {
                    slidesPerView: "auto",
                    spaceBetween: 16
                }
            }
        });
        if (select) select.addEventListener("change", ()=>{
            if (select.value !== "") this.swiper.slideTo(Number(select.value));
        });
    }
    disconnectedCallback() {
        this.swiper?.destroy();
    }
});


parcelRequire("2x8QE");
var $gD9Ug = parcelRequire("gD9Ug");
window.customElements.define("single-product-call-out", class extends HTMLElement {
    connectedCallback() {
        const container = this.querySelector(".swiper-container");
        if (!container) return;
        const config = {
            slidesPerView: 1,
            watchOverflow: true,
            pagination: {
                el: this.querySelector("[data-swiper-pagination]"),
                clickable: true
            },
            navigation: {
                nextEl: this.querySelector(".swiper-button-next"),
                prevEl: this.querySelector(".swiper-button-prev")
            }
        };
        this.swiper = new (0, $gD9Ug.default)(container, config);
    }
    disconnectedCallback() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
    }
});



/*-------------------------------------------- */ /** Router */ /*-------------------------------------------- */ (parcelRequire("hRgcM")).then((router)=>{
    router.init();
});

})();
//# sourceMappingURL=main.parcel.js.map
